import Axios from "axios";
import React, { Component } from "react";
import ReactTable from "react-table";
import _ from "lodash";
import Select from 'react-select';
import { toast } from "react-toastify";
import { SETTING } from "../app-config/cofiguration";
import "react-toastify/dist/ReactToastify.css";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { CustomInput } from 'reactstrap';
import BlockUi from "react-block-ui";
import Spinner from "../shared/Spinner";
import DatePicker from "react-datepicker";
//import imageCompression from 'browser-image-compression';
import { AvField, AvForm, AvInput } from "availity-reactstrap-validation";
import { ExportToCsv } from 'export-to-csv';
import { logoutFunc, classList, monthList, sessionList, monthNames, currentSession, monthListWithValue, decryptAESObj, otherPaymentTypeList, otherPaymentDuesTypeList, invoiceFormatData, getAllList, sendDueMessage, formatToIndianCurrency, isAdmissionInCurrentSession, addExamFees, getAdmissionSession, previousSession, uniformSizeChartList, encryptAES, formatPayOptionLabel } from "../util/helper";
import 'react-block-ui/style.css';
// import _uniqueId from 'lodash/uniqueId'
//const mime = require('mime')
import { generateInvoice } from "../util/pdfHelper";
import { AddNote } from "../AddNote";
import ScrollingText from "../shared/Scrolling";
toast.configure();

let USER = localStorage.getItem("userInformation") && JSON.parse(localStorage.getItem("userInformation"));
USER = decryptAESObj(USER)
const ROLENAME = USER && USER.userInfo && USER.userInfo.roleName

const currMonthForDues = new Date().getFinancialMonthIndex()
//const currMonthForDues= 12
const HalfYearlyMonthIndex = 6
const AnualExamMonthIndex = 12

export class Payment extends Component {
  constructor(props) {
    super(props);
    this.imageRef = React.createRef();
    this.state = {
      allPayDetail: [],
      copyOfAllPayDetail: [],
      selectedUser: {},
      paymentModal: false,
      loading: false,
      loading2: false,
      loading3: false,
      loading4: false,
      selectedFilter: '',
      totalAmount: 0,
      fineAmount: 0,
      concessionAmount: 0,
      busFee: 0,
      monthlyFee: 0,
      dueAmount: 0,
      excessAmount: 0,
      paidAmount: 0,
      preDueAmount: 0,
      preExcessAmount: 0,
      totalPaidAmount: 0,
      totalGrandAmount: 0,
      vehicleList: [],
      busRouteFareList: [],
      monthlyFeeList: [],
      payOptionList: [],
      updateMonthList: monthList,
      selectedMonth: '',
      payList: [{ payModeId: 'Cash', amount: 0 }],
      feeList: [{ month: '', monthlyFee: 0, busRouteId: '', busFee: 0 }],
      selectedClass: '1 A',
      submittedDate: new Date(),
      submittedDateError: false,
      paidMonthList: [],
      phoneNumber1: '',
      phoneNumber2: '',
      viewPaymentDetail: false,
      paymentRecieverUserList: [],
      selectedSession: currentSession(),
      selectedRow: {},
      userAllInvoice: [],
      userInvoice: [],
      allStudentUserIdList: [],
      allStudentPhoneList: [],
      selectedUserId: "",
      selectedPhoneNo: '',
      deleteLoading: false,
      duesAmount: 0,
      deleteModalShow: false,
      selectedPaymentId: '',
      otherPaymentList: [{ payFor: '', amount: 0 }],
      otherPaymentListWithMonth: [],
      examFeePayList: [],
      selectedCell: {},
      isPrint: false,
      loadingCal: false,
      totalDuesOfClass: null,
      deductionAmount: 0,
      isDeductionAmtUpdated: false,
      maxDeductionAmt: 50,
      userPayDetail: {},
    };

    this.handleSearch = this.handleSearch.bind(this)
    this.clearFilter = this.clearFilter.bind(this)
  }

  componentDidMount() {
    //this.getAllListCall()
    this.getAllPaymentDetail()
    //this.getPaymentRecieverUser()
  }
  // Function to determine readmission charge
  shouldApplyReadmissionCharge = (user, session) => {
    const admissionDate = (user && user.userInfo) ? user.userInfo.admissionDate : null
    if (!admissionDate) {
      return true;
    }
    const admissionSession = getAdmissionSession(admissionDate)
    if (admissionSession === session) {
      return false;
    } else {
      return true
    }
  }

  async getAllPaymentDetail() {
    this.setState({
      loading: true
    })
    const url = new URL(SETTING.APP_CONSTANT.API_URL + `admin/getPaymentDetail`)
    let urlSession = ''
    let urlUserId = ''
    let selectedSesion = this.state.selectedSession
    if (this.state.selectedClass) {
      url.searchParams.set('selectedClass', this.state.selectedClass)
    }
    if (this.state.inputSearch) {
      //url.searchParams.set('searchStr', this.state.inputSearch)
    }
    if (this.state.selectedUserId) {
      url.searchParams.set('userId', this.state.selectedUserId)
      url.searchParams.delete('selectedPhone', this.state.selectedUserId)
      url.searchParams.delete('searchStr', this.state.inputSearch)
      url.searchParams.delete('selectedClass', this.state.selectedClass)
    }
    if (this.state.selectedPhoneNo) {
      url.searchParams.set('selectedPhone', this.state.selectedPhoneNo)
      url.searchParams.delete('userId', this.state.selectedUserId)
      url.searchParams.delete('searchStr', this.state.inputSearch)
      url.searchParams.delete('selectedClass', this.state.selectedClass)
    }
    if (window.location.href.includes('payment?userId=')) {
      let params = new URLSearchParams(window.location.search);
      urlUserId = params.get('userId')
      urlSession = params.get('session')
      window.history.pushState('', '', '/payment');
      this.setState({ selectedUserId: urlUserId })
      url.searchParams.set('userId', urlUserId)
    }
    if (urlSession) {
      selectedSesion = urlSession
      url.searchParams.set('session', urlSession)
    } else {
      url.searchParams.set('session', this.state.selectedSession)
    }
    await this.getAllListCall(selectedSesion)
    let options = SETTING.HEADER_PARAMETERS;
    options['Authorization'] = localStorage.getItem("token")
    await Axios.get(url, { headers: options })
      .then((res) => {
        this.setState({
          loading: false
        })
        if (res && res.data.success) {
          // toast["success"](res.data.message);
          let totalDuesOfClass = 0

          const resData = (res.data.data && res.data.data.length > 0) ? res.data.data : []

          const allUserPayDetail = resData.map((data) => {
            const userDues = (selectedSesion === currentSession()) ? this.getDues(data) : this.getOldSessionDues(data)
            totalDuesOfClass += userDues.totalDues
            return { ...data, userDues }
          })

          this.setState({
            totalDuesOfClass: totalDuesOfClass,
            allPayDetail: allUserPayDetail,
            copyOfAllPayDetail: allUserPayDetail,
            selectedClass: (this.state.selectedUserId || urlUserId) && res.data && res.data.data && res.data.data.length > 0 && res.data.data[0] && res.data.data[0].userPayDetail && res.data.data[0].userPayDetail.class
              ? res.data.data[0].userPayDetail.class
              : this.state.selectedClass,
            selectedSession: urlSession ? urlSession : this.state.selectedSession
          })
        } else {
          toast["error"](res.data.message);
          this.setState({
            allPayDetail: [],
          })
        }
      })
      .catch((err) => {
        this.setState({
          loading: false
        })
        if (err && err.response && err.response.status === 401) {
          toast.error('Token expired.');
          logoutFunc()
        } else {
          const errorMessage = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : `Error while getting all payment.`
          toast["error"](errorMessage);
        }
      });
  }

  getAllListCall = async (session) => {
    const list = await getAllList(session)
    this.setState({
      vehicleList: list && list.vehicleList ? list.vehicleList : [],
      busRouteFareList: list && list.busRouteFareList ? list.busRouteFareList : [],
      monthlyFeeList: list && list.monthlyFeeList ? list.monthlyFeeList : [],
      payOptionList: list && list.payOptionList ? list.payOptionList : [],
      allStudentUserIdList: list && list.allStudentUserIdList ? list.allStudentUserIdList : [],
      allStudentPhoneList: list && list.allStudentPhoneList ? list.allStudentPhoneList : [],
      paymentRecieverUserList: list && list.paymentRecieverUserList ? list.paymentRecieverUserList : []
    })
  }

  async getPaymentRecieverUser() {
    this.setState({
      loading: true
    })
    let options = SETTING.HEADER_PARAMETERS;
    options['Authorization'] = localStorage.getItem("token")
    await Axios.get(SETTING.APP_CONSTANT.API_URL + `admin/getPaymentRecieverUser`, { headers: options })
      .then((res) => {
        // this.setState({
        //   loading:false
        // })
        if (res && res.data.success) {
          //toast["success"](res.data.message);
          this.setState({
            paymentRecieverUserList: res.data.data,
          })
        } else {
          toast["error"](res.data.message);
        }
      })
      .catch((err) => {
        this.setState({
          loading: false
        })
        if (err && err.response && err.response.status === 401) {
          toast.error('Token expired.');
          logoutFunc()
        } else {
          const errorMessage = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : `Error while getting payment reciever.`
          toast["error"](errorMessage);
        }
      })
  }

  async userUpdate(phoneNumber1, phoneNumber2) {
    const id = this.state.selectedUser._id
    let dataToSend = {
      phoneNumber1: phoneNumber1,
      phoneNumber2: phoneNumber2
      //concession:values.concession
    };

    let options = SETTING.HEADER_PARAMETERS;
    options['Authorization'] = localStorage.getItem("token")
    await Axios.post(SETTING.APP_CONSTANT.API_URL + `admin/updateUser/` + id, dataToSend, { headers: options })
      .then((res) => {
        this.setState({
          loading2: false
        })
        if (res && res.data.success) {
          toast["success"](res.data.message)
          this.handleClose()
        } else {
          toast["error"](res.data.message);
        }
      })
      .catch((err) => {
        this.setState({
          loading2: false
        })
        if (err && err.response && err.response.status === 401) {
          toast.error('Token expired.');
          logoutFunc()
        } else {
          const errorMessage = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : `Error while updating user.`
          toast["error"](errorMessage);
        }
      });
  }

  deletePaymentDetail = async () => {
    this.setState({
      loading: true
    })
    const url = new URL(SETTING.APP_CONSTANT.API_URL + `admin/deletePayment`)

    if (this.state.selectedPaymentId) {
      url.searchParams.set('paymentId', this.state.selectedPaymentId)
    }
    let options = SETTING.HEADER_PARAMETERS;
    options['Authorization'] = localStorage.getItem("token")
    await Axios.post(url, {}, { headers: options })
      .then((res) => {
        this.setState({
          loading: false,
          deleteModalShow: false
        })
        if (res && res.data.success) {
          toast["success"](res.data.message);
          this.getAllPaymentDetail()
        } else {
          toast["error"](res.data.message);
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
          deleteModalShow: false
        })
        if (err && err.response && err.response.status === 401) {
          toast.error('Token expired.');
          //logoutFunc()
        } else {
          const errorMessage = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : `Error while payment delete.`
          toast["error"](errorMessage);
        }
      });
  }

  handleClose = () => {
    this.setState({
      selectedUser: {},
      selectedMonth: '',
      editModal: false,
      loading: false,
      loading2: false,
      loading3: false,
      paymentModal: false,
      loading4: false,
      busRouteOption: false,
      totalAmount: 0,
      fineAmount: 0,
      concessionAmount: 0,
      busFee: 0,
      monthlyFee: 0,
      dueAmount: 0,
      excessAmount: 0,
      paidAmount: 0,
      payList: [{ payModeId: 'Cash', amount: 0 }],
      otherPaymentList: [{ payFor: '', amount: 0 }],
      otherPaymentListWithMonth: [],
      submittedDate: new Date(),
      submittedDateError: false,
      paidMonthList: [],
      //selectedSession: this.state.selectedSession? this.state.selectedSesion: currentSession(),
      viewPaymentDetail: false,
      contactModalShow: false,
      examName: "",
      exmaPayModalShow: false,
      otherPayModal: false,
      deleteModalShow: false,
      selectedPaymentId: '',
      noteModal: false,
      addNoteModalShow: false,
      userPayDetail: {}
    })
  }

  //debounecdSearch = _.debounce( () => {this.functionName()}, 1600);

  internalSearch = (searchString) => {
    let searchStr = searchString && searchString.trim()
    searchStr = searchStr ? searchStr.toLowerCase() : searchStr
    const filterData = this.state.copyOfAllPayDetail.filter(item => {
      const userInfo = item?.sData?.userInfo;
      if (!userInfo) return false;
      const search = searchStr.toLowerCase();
      return (
        userInfo.fullName?.toLowerCase().includes(search) ||
        userInfo.fatherName?.toLowerCase().includes(search) ||
        userInfo.motherName?.toLowerCase().includes(search) ||
        userInfo.userId?.toLowerCase().includes(search) ||
        userInfo.phoneNumber1?.toLowerCase().includes(search) ||
        userInfo.phoneNumber2?.toLowerCase().includes(search) ||
        userInfo.aadharNumber?.toLowerCase().includes(search) ||
        userInfo.email?.toLowerCase().includes(search)
      );
    });
    this.setState({ allPayDetail: filterData })
  }

  handleSearch(e) {
    const value = e.target.value
    this.setState({
      inputSearch: value,
      selectedUserId: "",
      selectedPhoneNo: ''
    }, () => this.internalSearch(value))
  }

  handleClass = (e) => {
    const value = e.target.value
    this.setState({
      selectedClass: value,
      selectedUserId: "",
      selectedPhoneNo: ''
    }, () => this.getAllPaymentDetail())
  }
  handleSession = (e) => {
    const value = e.target.value
    this.setState({
      selectedSession: value,
      selectedUserId: "",
      selectedPhoneNo: '',
    }, () => { this.getAllPaymentDetail(); })
    //this.getAllListCall(this.state.selectedSession);
  }
  clearFilter = () => {
    this.setState({
      inputSearch: "",
      selectedClass: '1 A',
      selectedSession: currentSession(),
      submittedDateError: false,
      submittedDate: new Date(),
      selectedUserId: "",
      selectedPhoneNo: '',
    }, () => { this.getAllPaymentDetail(); })
    //this.getAllListCall(this.state.selectedSession)
  }

  handleUserIdChange = (e) => {
    this.setState({
      selectedUserId: e.value,
      selectedPhoneNo: '',
      selectedClass: '',
      inputSearch: ''
    }, () => this.getAllPaymentDetail())
  }
  handlePhoneSearch = (e) => {
    this.setState({
      selectedPhoneNo: e.value,
      selectedClass: '',
      selectedUserId: '',
      inputSearch: ''
    }, () => this.getAllPaymentDetail())
  }
  handleSelectUserId = (userData, session) => {
    // this.setState({
    //   selectedUserId: userData.userInfo.userId,
    //   selectedSession: '2023-24'
    //  },()=> this.getAllPaymentDetail())
    const redireURL = `${window.location.host.includes('localhost') ? 'http://' : 'https://'}${window.location.host}/payment?userId=${userData.userInfo.userId}&&session=${session}`
    window.open(redireURL, "_blank")
  }

  // calculation=(action)=>{
  //   let amount= parseFloat(this.state.chargeAmount)
  //   let fineAmount= this.state.fineAmount && parseFloat(this.state.fineAmount)>0?parseFloat(this.state.fineAmount):0
  //   let concessionAmount= this.state.concessionAmount && parseFloat(this.state.concessionAmount)>0?parseFloat(this.state.concessionAmount):0
  //     this.setState({finalAmount: amount + fineAmount - concessionAmount})
  // }

  handlePaymentSubmit = async (e, values, submitType = '') => {
    if (this.state.submittedDate === "") {
      this.setState({ submittedDateError: true })
      return
    }
    if (this.state.submittedDateError) return
    this.setState({
      loading4: true
    })
    if (submitType === 'MONTHLY' && ((values.phoneNumber1 !== this.state.selectedUser.userInfo.phoneNumber1) || (values.phoneNumber2 && values.phoneNumber2 !== this.state.selectedUser.userInfo.phoneNumber2))) {
      this.userUpdate(values.phoneNumber1, values.phoneNumber2)
    }
    let dataToSend = {}
    if (submitType === 'MONTHLY') {
      dataToSend = {
        submitType: submitType,
        feeList: this.state.feeList,
        otherFeeList: values.otherPaymentWithMonth && values.otherPaymentWithMonth.length > 0 ? values.otherPaymentWithMonth.map(data => { return { name: data.payFor, amount: Number(data.amount) } }) : undefined,
        // fee:values.fee?values.fee:0,
        // busFee: values.busFee?values.busFee:0,
        // busRouteId : "64969713181b530028ee35e0",
        overDueAmount: values.preDueAmount,
        overExcessAmount: values.preExcessAmount,
        concession: values.concession ? values.concession : 0,
        dueAmount: values.dueAmount ? values.dueAmount : 0,
        excessAmount: values.excessAmount ? values.excessAmount : 0,
        fineAmount: values.fineAmount ? values.fineAmount : 0,
        paidAmount: values.paidAmount,
        totalGrandAmount: this.state.totalGrandAmount,
        payment: this.state.payList,
        paymentRecieverId: values.paymentRecieverId,
        totalAmount: values.totalAmount,
        submittedDate: this.state.submittedDate,
        insertedId: USER && USER._id,
        userId: this.state.selectedUser.userInfo.userId,
        class: this.state.selectedClass ? this.state.selectedClass : this.state.selectedUser.userInfo.class,
        session: this.state.selectedSession,
        receiptNumber: values.receiptNumber,
        notes: values.notes,
        phoneNumber1: values.phoneNumber1,
        phoneNumber2: values.phoneNumber2,
        paymentLedgerPage: values.paymentLedgerPage
      }
    }
    if (submitType === 'EXAM_FEE') {
      dataToSend = {
        submitType: submitType,
        otherFeeList: [{
          name: this.state.examName,
          amount: Number(values.payment[0].amount)
        }],
        paidAmount: Number(values.payment[0].amount),
        payment: this.state.payList,
        paymentRecieverId: values.paymentRecieverId,
        totalGrandAmount: Number(values.payment[0].amount),
        totalAmount: Number(values.payment[0].amount),
        submittedDate: this.state.submittedDate,
        insertedId: USER && USER._id,
        userId: this.state.selectedUser.userInfo.userId,
        class: this.state.selectedClass ? this.state.selectedClass : this.state.selectedUser.userInfo.class,
        session: this.state.selectedSession,
        receiptNumber: values.receiptNumber,
        notes: values.notes,
        paymentLedgerPage: values.paymentLedgerPage,
      }
    }
    if (submitType === 'OTHER_PAYMENT') {
      dataToSend = {
        submitType: submitType,
        otherFeeList: values.otherPayment.map(data => { return { name: data.payFor, amount: Number(data.amount) } }),
        paidAmount: Number(values.payment[0].amount),
        payment: this.state.payList,
        paymentRecieverId: values.paymentRecieverId,
        totalGrandAmount: Number(values.totalOtherPayAmount),
        totalAmount: Number(values.totalOtherPayAmount),
        submittedDate: this.state.submittedDate,
        insertedId: USER && USER._id,
        userId: this.state.selectedUser.userInfo.userId,
        class: this.state.selectedClass ? this.state.selectedClass : this.state.selectedUser.userInfo.class,
        session: this.state.selectedSession,
        receiptNumber: values.receiptNumber,
        dueAmount: values.dueOtherPay ? values.dueOtherPay : 0,
        dueFor: values.dueOtherPaymentType ? values.dueOtherPaymentType : '',
        concession: values.otherPayConcession ? values.otherPayConcession : 0,
        notes: values.notes,
        paymentLedgerPage: values.paymentLedgerPage,
      }
    }

    // const url= 'https://mercury-uat.phonepe.com/transact/simulator?token=c6K8TLzyIj6VS9QQ6fsa69tWzvHJEey789qXNblLIWK'
    // //const url = response.data.data.data.instrumentResponse.redirectInfo.url
    // this.setState({
    //   phonePeUrl: url,
    //   onlinePayModal: true
    // })

    //window.location.href = 'https://mercury-uat.phonepe.com/transact/simulator?token=9E7mYEWviFlagB06K1QIQg79RadeSuv6Js0eOYIDuc';
    // try {
    //   let options = SETTING.HEADER_PARAMETERS;
    //   options['Authorization'] = localStorage.getItem("token")
    //   //let fetchUrl = 'http://localhost:3010/api/admin/initiate-payment'
    //   let fetchUrl= 'http://localhost:3010/api/admin/sendMessage'
    //   const response = await Axios.post(fetchUrl, {
    //     amount:dataToSend.paidAmount,
    //     orderId:_.uniqueId(),
    //     customerId: dataToSend.userId,
    //   },{headers: options});
    // if (response.data.success) {
    //   //const url= 'https://mercury-uat.phonepe.com/transact/simulator?token=c6K8TLzyIj6VS9QQ6fsa69tWzvHJEey789qXNblLIWK'
    //   const url = response.data.data.data.instrumentResponse.redirectInfo.url
    //   this.setState({
    //     phonePeUrl: url,
    //     onlinePayModal: true
    //   })
    //   // window.location.href = response.data.data.data.instrumentResponse.redirectInfo.url;
    // }
    // } catch (error) {
    //   console.error('Payment initiation failed', error);
    // }

    let options = SETTING.HEADER_PARAMETERS;
    options['Authorization'] = localStorage.getItem("token")
    await Axios.post(SETTING.APP_CONSTANT.API_URL + `admin/addPayment`, dataToSend, { headers: options })
      .then((res) => {
        this.setState({
          loading4: false
        })
        if (res && res.data.success) {
          toast["success"](res.data.message)
          this.handleClose()
          this.getAllPaymentDetail();
          if (this.state.isPrint) {
            this.downloadPayDetail(res.data.invoiceId)
          }
          //window.location.reload();
        } else {
          toast["error"](res.data.message);
        }
      })
      .catch((err) => {
        this.setState({
          loading4: false
        })
        if (err && err.response && err.response.status === 401) {
          toast.error('Token expired.');
          logoutFunc()
        } else {
          const errorMessage = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : `Payment submission fail.`
          toast["error"](errorMessage);
        }
      });
  }

  handlePaymentSettingSubmit = async (e, values) => {
    this.setState({
      loading4: true
    })

    const dataToSend = {
      busOptionEnable: this.state.busRouteOption,
      busRouteId: values.busRouteId,
      userId: this.state.selectedUser.userInfo.userId,
      paymentId: this.state.selectedCell.userPayDetail._id,
      session: this.state.selectedSession,
      deductionAmt: this.state.isDeductionAmtUpdated ? this.state.deductionAmount : null,
      reason: this.state.isDeductionAmtUpdated ? values.reason : null,
      password: this.state.isDeductionAmtUpdated ? encryptAES(values.password) : null,
    }

    let options = SETTING.HEADER_PARAMETERS;
    options['Authorization'] = localStorage.getItem("token")
    await Axios.post(SETTING.APP_CONSTANT.API_URL + `admin/userPaymentSetting`, dataToSend, { headers: options })
      .then((res) => {
        this.setState({
          loading4: false
        })
        if (res && res.data.success) {
          toast["success"](res.data.message)
          this.closeOtherSettingModal()
          this.getAllPaymentDetail();
          //window.location.reload();
        } else {
          toast["error"](res.data.message);
        }
      })
      .catch((err) => {
        this.setState({
          loading4: false
        })
        if (err && err.response && err.response.status === 401) {
          toast.error('Token expired.');
          logoutFunc()
        } else {
          const errorMessage = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : `Payment setting submission fail.`
          toast["error"](errorMessage);
        }
      });
  }


  getTrProps = (state, rowInfo, instance) => {
    //f6e84e9e yellow
    //198ae347 blue
    if (rowInfo?.original?.sData?.isActive === false) {
      return {
        style: {
          'backgroundColor': '#f96868a1'
        }
      }
    }
    if (rowInfo && rowInfo.original.userPayDetail && rowInfo.original.userPayDetail.feeFree) {
      return {
        style: {
          'backgroundColor': '#b5deaa',
        }
      }
    }
    if (rowInfo && rowInfo.original.userPayDetail && rowInfo.original.userPayDetail.busService) {
      return {
        style: {
          'backgroundColor': '#198ae347',
        }
      }
    }
    return {};
  }
  getCellProps = (cell, month, preDueAmount, preExcessAmount, userPayDetail) => {
    const { monthlyFeeList, updateMonthList } = this.state
    const feeData = this.state.monthlyFeeList.find(data => data.className === cell?.userPayDetail?.class)
    let examFeePayList = []
    if (cell?.userPayDetail?.other?.length > 0) {

      if (!(cell.userPayDetail.other.find(item => item.name === 'HALF YEARLY EXAM'))) {
        examFeePayList.push({ label: "Half Yearly Exam", value: 'HALF YEARLY EXAM', amount: feeData?.halfExamFee })
      }
      if (!(cell.userPayDetail.other.find(item => item.name === 'ANNUAL EXAM'))) {
        examFeePayList.push({ label: "Annual Exam", value: 'ANNUAL EXAM', amount: feeData?.annualExamFee })
      }

    } else {
      examFeePayList = [{ label: "Half Yearly Exam", value: 'HALF YEARLY EXAM', amount: feeData?.halfExamFee }, { label: "Annual Exam", value: 'ANNUAL EXAM', amount: feeData?.annualExamFee }]
    }

    // let preDueAmount = dueAmount
    // let preExcessAmount=  excessAmount
    // const allMonthListPaid= Object.keys(userPayDetail)
    // .filter(key => userPayDetail[key]?.paidTtrue ===true)
    // .map(key => userPayDetail[key]);
    const paidMonthList = userPayDetail ? Object.keys(userPayDetail).map(key => userPayDetail[key]?.paidStatus ? key : undefined).filter(filter => !!filter) : []
    const enableMonthList = cell ? Object.keys(cell).map(key => cell[key]?.payEnable ? key : undefined).filter(filter => !!filter) : []
    // const monthlyFee = monthlyFeeList.find(data => data.className === cell.userInfo.class).monthlyFee
    // const busFee = cell.userInfo.busService? this.state.busRouteFareList.find(data => data._id === cell.userInfo.busRouteId).fare: 0
    const isMonthFeeFree = cell.userPayDetail && !!cell.userPayDetail.feeFree
    const monthlyFee = isMonthFeeFree ? 0 : cell[month] && cell[month].monthlyFee ? cell[month].monthlyFee : 0
    const busFee = cell[month] && cell[month].busFee ? cell[month].busFee : 0
    const concessionAmount = cell.userPayDetail.deductionInfo?.amt || 0
    // console.log("isMonthFeeFree",isMonthFeeFree, "monthlyFee",monthlyFee,'busFee', busFee,'preDueAmount',preDueAmount, 'preExcessAmount', preExcessAmount )
    this.setState({
      userPayDetail: cell.userPayDetail,
      paymentModal: true,
      selectedUser: cell.sData,
      selectedMonth: month,
      paidMonthList: paidMonthList,
      updateMonthList: enableMonthList.filter(item => ![...paidMonthList, month].includes(item)),
      monthlyFee,
      busFeeActive: cell.userPayDetail.busService,
      busFee,
      examFeePayList,
      concessionAmount,
      preDueAmount: preDueAmount,
      preExcessAmount: preExcessAmount,
      busRouteId: cell.userPayDetail.busService ? cell.sData.userInfo.busRouteId : '',
      feeList: [{ month: month, monthlyFee: monthlyFee, busRouteId: cell.userPayDetail.busService ? cell.userPayDetail.busRouteId : '', busFee: busFee }],
      totalAmount: parseInt(monthlyFee) + parseInt(busFee) + parseInt(preDueAmount) - parseInt(preExcessAmount) - parseInt(concessionAmount)
    })

  }
  calculatePaymentAmount = () => {
    const { payList, fineAmount, concessionAmount, feeList, preDueAmount, preExcessAmount, otherPaymentListWithMonth } = this.state
    let paidAmount = 0
    let allSelectedMonthFee = 0
    let allSelectedBusFee = 0
    let otherPayAmount = 0
    payList.forEach(data => {
      if (!!data.amount && Number(data.amount)) {
        paidAmount += parseInt(data.amount)
      }
    })
    feeList.forEach(data => {
      if (!!data.monthlyFee && Number(data.monthlyFee)) {
        allSelectedMonthFee += parseInt(data.monthlyFee)
      }
      if (!!data.busFee && Number(data.busFee)) {
        allSelectedBusFee += parseInt(data.busFee)
      }
    })
    otherPaymentListWithMonth.forEach(data => {
      if (!!data.payFor && !!data.amount && Number(data.amount)) {
        otherPayAmount += parseInt(data.amount)
      }
    })

    //  console.log("allSelectedMonthFee", allSelectedMonthFee)
    //  console.log("allSelectedBusFee", allSelectedBusFee)
    //  console.log("fineAmount", fineAmount)
    //  console.log("concessionAmount", concessionAmount)
    //  console.log("preExcessAmount", preExcessAmount);
    //  console.log("preDueAmount", preDueAmount);
    let totalAmount = (parseInt(allSelectedMonthFee) + parseInt(allSelectedBusFee) + parseInt(otherPayAmount) + parseInt(fineAmount) - parseInt(concessionAmount) - parseInt(preExcessAmount) + parseInt(preDueAmount))
    let totalGrandAmount = (parseInt(allSelectedMonthFee) + parseInt(allSelectedBusFee) + parseInt(otherPayAmount) + parseInt(fineAmount) - parseInt(preExcessAmount) + parseInt(preDueAmount))
    let excessAmount = (paidAmount > totalAmount) ? paidAmount - totalAmount : 0
    let dueAmount = (totalAmount > paidAmount) ? totalAmount - paidAmount : 0
    this.setState({ paidAmount, totalAmount, excessAmount, dueAmount, totalGrandAmount })
  }
  calculateOtherPaymentAmount = () => {
    const { seletedCell, otherPaymentList, otherPayConcessionAmount, dueOtherPayAmount, payList } = this.state
    let otherPayDueAmount = 0
    let totalOtherPayAmount = 0
    otherPaymentList.forEach(data => {
      if (!!data.amount && Number(data.amount)) {
        totalOtherPayAmount += parseInt(data.amount)
      }
    })
    let otherPaidAmount = totalOtherPayAmount - parseInt(otherPayConcessionAmount ? otherPayConcessionAmount : 0) - parseInt(dueOtherPayAmount ? dueOtherPayAmount : 0)
    this.setState({
      otherPaidAmount, totalOtherPayAmount, otherPayDueAmount,
      payList: [
        {
          payModeId: payList && payList.length > 0 && payList[0].payModeId ? payList[0].payModeId : 'Cash',
          amount: otherPaidAmount
        }]
    })

  }
  updatePaymentField = (rowIndex, key) => e => {
    let data = [...this.state.payList]
    if (key === 'amount') {
      data[rowIndex][key] = e.target.value && !isNaN(e.target.value) ? e.target.value : 0
    } else {
      data[rowIndex][key] = e.target.value
    }
    this.setState({ payList: data },
      //()=> this.calculatePaymentAmount()
    )
  }
  updateOtherPaymentField = (rowIndex, key) => e => {
    let data = [...this.state.otherPaymentList]
    if (key === 'amount') {
      data[rowIndex][key] = e.target.value && !isNaN(e.target.value) ? Number(e.target.value) : 0
    } else {
      const oldkey = data[rowIndex][key]
      data[rowIndex][key] = e.target.value
      data[rowIndex]['amount'] = oldkey === e.target.value && data[rowIndex]['amount'] && Number(data[rowIndex]['amount']) > 0 ? Number(data[rowIndex]['amount']) : [...otherPaymentTypeList, ...otherPaymentDuesTypeList, ...uniformSizeChartList].find(data => data.value === e.target.value).amount || 0
    }
    this.setState({ otherPaymentList: data },
      () => this.calculateOtherPaymentAmount()
    )
  }
  updateOtherPaymentWithMonthField = (rowIndex, key) => e => {
    let data = [...this.state.otherPaymentListWithMonth]
    if (key === 'amount') {
      data[rowIndex][key] = e.target.value && !isNaN(e.target.value) ? Number(e.target.value) : 0
    } else {
      const oldkey = data[rowIndex][key]
      data[rowIndex][key] = e.target.value
      data[rowIndex]['amount'] = oldkey === e.target.value && data[rowIndex]['amount'] && Number(data[rowIndex]['amount']) > 0 ? Number(data[rowIndex]['amount']) : [...otherPaymentTypeList, ...this.state.examFeePayList].find(data => data.value === e.target.value).amount || 0
    }
    this.setState({ otherPaymentListWithMonth: data },
      () => this.calculatePaymentAmount()
    )
  }
  calculatePaymentField = (e, rowIndex) => {
    let data = [...this.state.payList]
    let num = !!data[rowIndex].amount ? data[rowIndex].amount : 0
    this.setState({ payList: data }, () => this.calculatePaymentAmount())
  }

  onAmountChange = (e, type) => {
    if (type === 'fine') {
      this.setState({ fineAmount: parseFloat(e.target.value && !isNaN(e.target.value) ? e.target.value : 0) }, () => this.calculatePaymentAmount())
    }
    if (type === 'concession') {
      this.setState({ concessionAmount: parseFloat(e.target.value && !isNaN(e.target.value) ? e.target.value : 0) }, () => this.calculatePaymentAmount())
    }
    if (type === 'otherPayConcession') {
      this.setState({ otherPayConcessionAmount: parseFloat(e.target.value && !isNaN(e.target.value) ? e.target.value : 0) }, () => this.calculateOtherPaymentAmount())
    }
    if (type === 'dueOtherPay') {
      this.setState({ dueOtherPayAmount: parseFloat(e.target.value && !isNaN(e.target.value) ? e.target.value : 0) }, () => this.calculateOtherPaymentAmount())
    }
  }

  addRow = (action) => {
    if (action === 'feeList') {
      let list = this.state.feeList
      const { busFee, busRouteId, busFeeActive, monthlyFee } = this.state
      const newRow = { month: '', monthlyFee: monthlyFee, busRouteId: busFeeActive ? busRouteId : '', busFee: busFeeActive ? busFee : 0 }
      list.push(newRow)
      this.setState({ feeList: list })
    }
    if (action === 'payList') {
      let list = this.state.payList
      const newRow = { payModeId: '', amount: 0 }
      list.push(newRow)
      this.setState({ payList: list })
    }
    if (action === 'otherPayList') {
      let list = this.state.otherPaymentList
      const newRow = { payFor: '', amount: 0 }
      list.push(newRow)
      this.setState({ otherPaymentList: list })
    }
    if (action === 'otherPayListWithMonth') {
      let list = this.state.otherPaymentListWithMonth
      const newRow = { payFor: '', amount: 0 }
      list.push(newRow)
      this.setState({ otherPaymentListWithMonth: list })
    }

  }
  removeRow = (indexNum, actionName) => {
    if (actionName === 'payList') {
      let list = this.state.payList
      if (list.length === 1) return toast['error']('This payment row is required.')
      list.splice(indexNum, 1)
      this.setState({ payList: list }, () => this.calculatePaymentAmount())
    }
    if (actionName === 'feeList') {
      let list = this.state.feeList
      if (list.length === 1) return toast['error']('This row is required.')
      const monthName = list[indexNum].month
      let monthList = this.state.updateMonthList
      monthList.push(monthName)
      list.splice(indexNum, 1)
      this.setState({ feeList: list, updateMonthList: monthList }, () => this.calculatePaymentAmount())
    }
    if (actionName === 'otherPayList') {
      let list = this.state.otherPaymentList
      if (list.length === 1) return toast['error']('This row is required.')
      list.splice(indexNum, 1)
      this.setState({ otherPaymentList: list }, () => this.calculateOtherPaymentAmount())
    }
    if (actionName === 'otherPayListWithMonth') {
      let list = this.state.otherPaymentListWithMonth
      list.splice(indexNum, 1)
      this.setState({ otherPaymentListWithMonth: list }, () =>
        this.calculatePaymentAmount()
      )
    }
  }
  locationRedirect = (cell) => {
    window.location.href = `${window.location.host.includes('localhost') ? 'http://' : 'https://'}${window.location.host}/allstudent?id=${cell._id}`
  }
  changeMonth = (e, rowIndex, key) => {
    const { concessionAmount } = this.state
    let data = [...this.state.feeList]
    data[rowIndex][key] = e.target.value
    let deductionAmount = this.state.userPayDetail?.deductionInfo?.amt || 0
    let newConsessionAmt = deductionAmount && Number(deductionAmount) > 0 ? parseInt(deductionAmount) * data.length: concessionAmount
    this.setState({
      updateMonthList: this.state.updateMonthList.filter(data => data !== e.target.value),
      feeList: data,
      concessionAmount: newConsessionAmt
    }, () => this.calculatePaymentAmount())
  }

  handleChange = date => {
    this.setState({
      submittedDateError: false,
      submittedDate: date
    });
  };
  // changePay =(e, rowIndex, key)=>{

  //   let data= [...this.state.feeList]
  //   data[rowIndex][key] = e.target.value
  //   this.setState({
  //     updateMonthList: this.state.updateMonthList.filter(data=> data!==e.target.value),
  //     feeList: data
  //   },()=>this.calculatePaymentAmount())
  // }

  amtShow = (amt) => {
    return <span style={{ color: `${amt > 0 ? 'green' : ''}`, fontWeight: `${amt > 0 ? 'bold' : ''}` }}>{amt}</span>
  }

  onChangePhoneNumber = actionName => (e) => {
    if (e.target.value && e.target.value.length === 10) {
      if (actionName === 'phoneNumber1') {
        if ((this.state.phoneNumber2 && e.target.value === this.state.phoneNumber2) || (e.target.value === this.state.selectedUser.userInfo.phoneNumber2)) {
          toast["error"]("Phone number same");
        }
        this.setState({
          phoneNumber1: e.target.value
        })
      }
      if (actionName === 'phoneNumber2') {
        if ((this.state.phoneNumber1 && e.target.value === this.state.phoneNumber1) || (e.target.value === this.state.selectedUser.userInfo.phoneNumber1)) {
          toast["error"]("Phone number same");
        }
        this.setState({
          phoneNumber2: e.target.value
        })
      }
    }
  }
  checkAdmissionDate = (user, columnMonth) => {
    let pay = true
    if (user.userInfo.admissionDate) {
      let columnMonthIndex = monthNames.indexOf(columnMonth.toLowerCase())
      const admissionDate = new Date(user.userInfo.admissionDate)
      const admissionDay = admissionDate.getDate()
      const admissionYear = admissionDate.getFullYear()
      const admissionMonthIndex = admissionDate.getMonth()
      let admissionSession = ''
      if (admissionMonthIndex >= 3) {
        admissionSession = `${(admissionYear).toString()}-${(admissionYear + 1).toString().substring(2)}`
      } else if (admissionMonthIndex < 3) {
        admissionSession = `${(admissionYear - 1).toString()}-${(admissionYear).toString().substring(2)}`
      }
      if (columnMonthIndex >= 3 && currentSession() === admissionSession && (admissionMonthIndex > columnMonthIndex || (admissionMonthIndex === columnMonthIndex && admissionDay >= 20 || (admissionMonthIndex < 3 && admissionMonthIndex < columnMonthIndex)))) {
        pay = false

      }
      else if (columnMonthIndex < 3 && admissionMonthIndex < 3 && currentSession() === admissionSession && (admissionMonthIndex > columnMonthIndex || (admissionMonthIndex === columnMonthIndex && admissionDay >= 20))) {
        pay = false
      }
    }
    return pay

  }
  getInvoicesByUserId = async () => {
    const { selectedRow, selectedSession } = this.state
    this.setState({
      loading: true
    })
    let options = SETTING.HEADER_PARAMETERS;
    options['Authorization'] = localStorage.getItem("token")
    const url = new URL(SETTING.APP_CONSTANT.API_URL + `admin/getInvoicesByUserId`)
    url.searchParams.set('session', selectedSession ? selectedSession : '')
    url.searchParams.set('userId', selectedRow.sData.userInfo.userId)


    await Axios.get(url, { headers: options })
      .then((res) => {
        if (res && res.data.success) {
          //toast["success"](res.data.message);
          let userAllInvoice = res.data.data
          this.setState({
            viewPaymentDetail: true,
            selectedUser: selectedRow.sData,
            userInvoice: monthList.map(monthName => {
              return {
                ...selectedRow,
                monthName,
                userAllInvoice
              }
            }),
            totalPaidAmount: userAllInvoice.reduce((sum, curr) => sum + Number(curr.amount), 0),
            userAllInvoice: userAllInvoice
          })
        } else {
          toast["error"](res.data.message);
        }
      })
      .catch((err) => {
        this.setState({
          loading: false
        })
        if (err && err.response && err.response.status === 401) {
          toast.error('Token expired.');
          logoutFunc()
        } else {
          const errorMessage = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : `Error while getting payment reciever.`
          toast["error"](errorMessage);
        }
      })
  }

  deleteTransactionByInvoiceId = async (invoiceId) => {
    this.setState({
      deleteLoading: true
    })
    const payLoad = {
      invoiceId: invoiceId,
      session: this.state.selectedSession
    }
    let options = SETTING.HEADER_PARAMETERS;
    options['Authorization'] = localStorage.getItem("token")
    const url = new URL(SETTING.APP_CONSTANT.API_URL + `admin/deleteTransaction`)

    await Axios.post(url, payLoad, { headers: options })
      .then((res) => {
        this.setState({
          deleteLoading: false
        })
        if (res && res.data.success) {
          const filterInvoice = this.state.userAllInvoice.filter(fData => fData.invoiceId !== invoiceId)
          const userMonthlyInvoice = this.userMonthlyInvoiceReturn(filterInvoice)
          this.setState({
            userAllInvoice: filterInvoice,
            userMonthlyInvoice: userMonthlyInvoice,
            userOtherInvoice: this.userOtherInvoiceReturn(filterInvoice),
            pageSizeOfViewPayment: this.pageSizeCount(userMonthlyInvoice)
          })
          this.getAllPaymentDetail()
          toast["success"](res.data.message);
        } else {
          toast["error"](res.data.message);
        }
      })
      .catch((err) => {
        this.setState({
          deleteLoading: false
        })
        if (err && err.response && err.response.status === 401) {
          toast.error('Token expired.');
          logoutFunc()
        } else {
          const errorMessage = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : `Error while getting payment reciever.`
          toast["error"](errorMessage);
        }
      })
  }

  pageSizeCount = (userInvoiceData) => {
    let mCount = 0
    let rowCount = 0
    for (const it of userInvoiceData) {
      if (it.invoiceInfo.feeList && it.invoiceInfo.feeList.length) {
        mCount += it.invoiceInfo.feeList.length
        rowCount++
      }
    }

    return 12 - mCount + rowCount
  }

  userMonthlyInvoiceReturn = (allInvoice) => {
    return allInvoice.map(item => {
      const { invoiceInfo: { otherFeeList, ...restInvoiceInfo }, ...restItem } = item
      if (item.invoiceInfo.feeList) {
        return {
          ...restItem,
          invoiceInfo: {
            ...restInvoiceInfo
          }
        }
      }
    }).filter(notUndefined => notUndefined !== undefined)
  }
  userOtherInvoiceReturn = (allInvoice) => {
    return allInvoice.map(item => {
      const { invoiceInfo: { feeList, ...restInvoiceInfo }, ...restItem } = item
      if (item.invoiceInfo.otherFeeList) {
        return {
          ...restItem,
          invoiceInfo: {
            ...restInvoiceInfo
          }
        }
      }
    }).filter(notUndefined => notUndefined !== undefined)
  }

  actionTogle = async (cell, action) => {
    if (action === 'VeiwDetail') {
      const userMonthlyInvoice = this.userMonthlyInvoiceReturn(cell.userInvoiceDetail)
      this.setState({
        viewPaymentDetail: true,
        selectedUser: { ...cell.sData, paymentLedgerPage: cell.userPayDetail.paymentLedgerPage },
        userAllInvoice: cell.userInvoiceDetail,
        userMonthlyInvoice: userMonthlyInvoice,
        userOtherInvoice: this.userOtherInvoiceReturn(cell.userInvoiceDetail),
        pageSizeOfViewPayment: this.pageSizeCount(userMonthlyInvoice)
      })
    }
    if (action === 'contact') {
      const { totalDues = 0 } = cell.userDues
      this.setState({
        selectedUser: cell.sData,
        contactModalShow: true,
        duesAmount: totalDues
      })
    }
    if (action === 'deletePayment') {
      this.setState({
        selectedPaymentId: cell.userPayDetail && cell.userPayDetail._id,
        deleteModalShow: true,
      })
    }
    if (action === 'otherPayment') {
      let oldOtherPaymentList = []
      let dueAmt = 0
      const oldOtherDue = cell.userPayDetail && cell.userPayDetail.otherDue
      if (oldOtherDue) {
        for (const key in oldOtherDue) {
          if (oldOtherDue[key] && Number(oldOtherDue[key]) > 0) {
            dueAmt += Number(oldOtherDue[key])
            oldOtherPaymentList = [...oldOtherPaymentList, { payFor: key, amount: Number(oldOtherDue[key]) }]
          }
        }
      }
      if (Number(cell.userPayDetail.dueAmount) > 0 && cell.userPayDetail['march'] && cell.userPayDetail['march'].paidStatus) {
        dueAmt += Number(cell.userPayDetail.dueAmount)
        oldOtherPaymentList = [...oldOtherPaymentList, { payFor: 'dueMarch_Month_Bus', amount: Number(cell.userPayDetail.dueAmount) }]
      }
      this.setState({
        selectedCell: cell,
        selectedUser: cell.sData,
        userPayDetail: cell.userPayDetail,
        otherPaymentList: dueAmt > 0 ? oldOtherPaymentList : [{ payFor: '', amount: 0 }],
        otherPayModal: true,
        dueOtherPayAmount: 0,
        otherPayConcessionAmount: 0,
        totalOtherPayAmount: dueAmt,
        payList: [{ payModeId: 'Cash', amount: dueAmt }],
      })
    }
    if (action === 'reAdmission') {
      const upperClassName = classList.filter(data => Number(data.split(' ')[0]) > 0)
      const reAdmissClassType = upperClassName.includes(cell.sData.userInfo.class) ? 'reAdmissionUpper' : 'reAdmissionUnder'
      const reAdmissionList = otherPaymentTypeList.find(data => data.value === reAdmissClassType)
      this.setState({
        selectedCell: cell,
        selectedUser: cell.sData,
        userPayDetail: cell.userPayDetail,
        otherPaymentList: [{ payFor: reAdmissionList.value, amount: reAdmissionList.amount }],
        otherPayModal: true,
        dueOtherPayAmount: 0,
        otherPayConcessionAmount: 0,
        totalOtherPayAmount: reAdmissionList.amount,
        payList: [{ payModeId: 'Cash', amount: reAdmissionList.amount }],
      })
    }
    if (action === 'dueMessage') {
      let userId = cell.sData.userInfo.userId
      const { totalDues = 0 } = cell.userDues
      const number1 = cell.sData && cell.sData && cell.sData.userInfo && cell.sData.userInfo.phoneNumber1
      const number2 = cell.sData && cell.sData && cell.sData.userInfo && cell.sData.userInfo.phoneNumber1
      if (!!number1) {
        const messageStatus = await sendDueMessage(number1, userId, totalDues)
        if (messageStatus && messageStatus.status) {
          toast['success'](messageStatus.message)
        } else {
          toast["error"](messageStatus && messageStatus.message ? messageStatus.message : 'Message not sent')
        }
      }
      if (!!number2 && number1 !== number2) {
        const messageStatus = await sendDueMessage(number2, userId, totalDues)
        if (messageStatus && messageStatus.status) {
          toast['success'](messageStatus.message)
        } else {
          toast["error"](messageStatus && messageStatus.message ? messageStatus.message : 'Message not sent')
        }
      }
    }
    if (action === 'addNoteAction') {
      this.setState({
        selectedUser: cell.sData,
        addNoteModalShow: true
      })
    }
    if (action === 'paySetting') {
      const feeData = this.state?.monthlyFeeList.find(data => data.className === cell.userPayDetail?.class) || {};
      this.setState({
        selectedUser: cell.sData,
        selectedCell: cell,
        paymentSetting: true,
        busRouteOption: cell.userPayDetail.busService,
        deductionAmount: cell.userPayDetail.deductionInfo?.amt || 0,
        maxDeductionAmt: feeData?.monthlyFee || this.state.maxDeductionAmt
      })
    }
  }
  noteDetail = (cell) => {
    this.setState({
      noteModal: true,
      noteData: cell.invoiceInfo.notes
    })
  }
  handleCloseNoteModal = () => {
    this.setState({
      noteModal: false,
      noteData: ''
    })
  }
  handleCloseOnlinePayModal = () => {
    this.setState({
      phonePeUrl: '',
      onlinePayModal: false
    })
  }
  closeOtherSettingModal = () => {
    this.setState({
      paymentSetting: false,
      isDeductionAmtUpdated: false
    })
  }

  busServiceCheckHandle = (e) => {
    this.setState({ busRouteOption: e.target.checked })
  }

  copyToClipBoard(text) {
    text = text.replaceAll('-', '')
    const heloxPin = document.createElement('textarea')
    heloxPin.value = text;
    document.body.appendChild(heloxPin);
    heloxPin.select();
    document.execCommand('copy');
    document.body.removeChild(heloxPin)
    toast.success('Phone Number Copied');

  }

  downloadPayDetail = async (invoiceId) => {
    let options = SETTING.HEADER_PARAMETERS;
    options['Authorization'] = localStorage.getItem("token")
    await Axios.get(SETTING.APP_CONSTANT.API_URL + `admin/getAllInvoice?invoiceId=` + invoiceId, { headers: options })
      .then((res) => {
        this.setState({
          loading4: false
        })
        if (res && res.data.success) {
          let invoiceData = res.data.data[0]
          const isPrint = this.state.isPrint
          //generateInvoice(invoiceFormatData(invoiceData),isPrint)
          generateInvoice(invoiceFormatData(invoiceData), isPrint).then((pdfBlob) => {
            const fileURL = URL.createObjectURL(pdfBlob);
            const pdfWindow = window.open(fileURL);
            pdfWindow.onload = () => {
              pdfWindow.print();
            };
          });
        } else {
          toast["error"](res.data.message);
        }
      })
      .catch((err) => {
        this.setState({
          loading4: false
        })
        if (err && err.response && err.response.status === 401) {
          toast.error('Token expired.');
          logoutFunc()
        } else {
          const errorMessage = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : `Invoice detail not found.`
          toast["error"](errorMessage);
        }
      });
  }
  exportDuesCSV = () => {
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: `${this.state.selectedClass ? 'Class' + this.state.selectedClass : ''}(${new Date().getFullYear()} - ${(new Date().getFullYear() + 1).toString().slice(2)})Dues-${(monthNames[new Date().getMonth()]).toUpperCase()}`,
      useTextFile: false,
      filename: `${this.state.selectedClass ? (this.state.selectedClass).split(" ").join("_") + '_' : ''}Dues_${new Date().getFullYear()}_${(new Date().getFullYear() + 1).toString().slice(2)}_${monthNames[new Date().getMonth()]}`,
      useBom: true,
      // useKeysAsHeaders: true,
      headers: ['S.No.', 'BMMSID', 'Student Name', 'Father Name', ...monthList.map(name =>
        name === 'january' ? 'JANU'
          : name === 'february' ? 'FEBR'
            : name === 'august' ? 'AUGU'
              : name === 'september' ? 'SEPT'
                : name === 'october' ? 'OCTO'
                  : name === 'november' ? 'NOVE'
                    : name === 'december' ? 'DECE'
                      : name.toUpperCase()
      ),
        'Total Dues', 'Phone Number 1', 'Phone Number 2']
    };

    let csvData = this.state.copyOfAllPayDetail.map((data, index) => {
      const { totalDues = 0 } = data.userDues
      const newData = {
        sno: (index + 1) + '\t',
        bmmsId: data.sData.userInfo.userId + '\t',
        studentName: data.sData.userInfo.fullName,
        fatherName: data.sData.userInfo.fatherName,
        april: data['april'].payEnable ? data['april'].amt : '###',
        may: data['may'].payEnable ? data['may'].amt : '###',
        june: data['june'].payEnable ? data['june'].amt : '###',
        july: data['july'].payEnable ? data['july'].amt : '###',
        august: data['august'].payEnable ? data['august'].amt : '###',
        september: data['september'].payEnable ? data['september'].amt : '###',
        october: data['october'].payEnable ? data['october'].amt : '###',
        november: data['november'].payEnable ? data['november'].amt : '###',
        december: data['december'].payEnable ? data['december'].amt : '###',
        january: data['january'].payEnable ? data['january'].amt : '###',
        february: data['february'].payEnable ? data['february'].amt : '###',
        march: data['march'].payEnable ? data['march'].amt : '###',
        dues: totalDues,
        phoneNumber1: data.sData.userInfo.phoneNumber1,
        phoneNumber2: data.sData.userInfo.phoneNumber2 ? data.sData.userInfo.phoneNumber2 : '',
        //bmmsId:`="${data.userInfo.userId}"`,
        //bmmsId:data.userInfo.userId+"\t",
        //classd:data.userInfo.class+"\t",
        //fullName:data.userInfo.fullName,
      }
      return newData
    })

    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(csvData);
  }

  getDues = (cellData) => {
    let paidAmt = 0
    let dueAmt = 0

    let userDues = {
      monthlyFee: 0,
      busFee: 0,
      prevYearAmtDue: Number(cellData.prevYearAmtDue || 0),
      preDueAmount: Number(cellData.preDueAmount || 0),
      halfExamFee: 0,
      annualExamFee: 0,
      reAdmissionFee: 0,
      preExcessAmount: 0, // minus this amount
      otherDue: 0,
      totalDues: 0
    };

    const preExcessAmount = cellData.preExcessAmount
    const feeData = this.state.monthlyFeeList.find(data => data.className === cellData.userPayDetail.class)
    const isOtherPay = (cellData.userPayDetail && cellData.userPayDetail.other && cellData.userPayDetail.other.length > 0) ? true : false
    const isMonthFeeFree = !!cellData.userPayDetail.feeFree
    const isAnnualExamFeeNotPaid = isOtherPay ? !cellData.userPayDetail.other.some(data => data.name === 'ANNUAL EXAM') : true
    const isHalfExamFeeNotPaid = isOtherPay ? !cellData.userPayDetail.other.some(data => data.name === 'HALF YEARLY EXAM') : true
    const consessionAmt = cellData.userPayDetail?.deductionInfo?.amt ? Number(cellData.userPayDetail?.deductionInfo?.amt) : 0
    if (currMonthForDues >= 5) { // After august
      if (cellData.sData.userInfo.admissionDate) {
        const admissionDate = new Date(cellData.sData.userInfo.admissionDate);
        const admissionMonthIndex = admissionDate.getFinancialMonthIndex(); // APRIL 1 & MARCH 12
        const admissionSession = getAdmissionSession(cellData.sData.userInfo.admissionDate);
        const isCurrentSession = isAdmissionInCurrentSession(admissionSession, currentSession());
        if (isCurrentSession) {
          if (admissionMonthIndex < HalfYearlyMonthIndex && isHalfExamFeeNotPaid) {
            userDues.halfExamFee = addExamFees(feeData, false, true)
          }
          if (admissionMonthIndex < AnualExamMonthIndex && (currMonthForDues === 11 || currMonthForDues === 12) && isAnnualExamFeeNotPaid) {
            userDues.annualExamFee = addExamFees(feeData, true, false)
          }
        } else {
          if (isHalfExamFeeNotPaid) {
            userDues.halfExamFee = addExamFees(feeData, false, true)
          }
          if ((currMonthForDues === 11 || currMonthForDues === 12) && isAnnualExamFeeNotPaid) {
            userDues.annualExamFee = addExamFees(feeData, true, false)
          }
        }
      } else {
        if (isHalfExamFeeNotPaid) {
          userDues.halfExamFee = addExamFees(feeData, false, true)
        }
        if ((currMonthForDues === 11 || currMonthForDues === 12) && isAnnualExamFeeNotPaid) {
          userDues.annualExamFee = addExamFees(feeData, true, false)
        }
      }
    }

    const isReadmissionCharge = this.shouldApplyReadmissionCharge(cellData.sData, currentSession());
    if (isReadmissionCharge) {
      const reAdmUp = 'reAdmissionUpper'
      const reAdmUn = 'reAdmissionUnder'
      const reAdmissionData = cellData.userPayDetail && cellData.userPayDetail.other && cellData.userPayDetail.other.length > 0 && cellData.userPayDetail.other.find(data => (data.name == reAdmUp || data.name == reAdmUn))
      if (!reAdmissionData) {
        const upperClassName = classList.filter(data => Number(data.split(' ')[0]) > 0)
        const reAdmissClassType = upperClassName.includes(cellData.sData.userInfo.class) ? reAdmUp : reAdmUn
        const reAdmissionList = otherPaymentTypeList.find(data => data.value === reAdmissClassType)
        userDues.reAdmissionFee = Number(reAdmissionList.amount)
      }
    }

    if (cellData.userPayDetail && cellData.userPayDetail.otherDue) {
      for (const key in cellData.userPayDetail.otherDue) {
        userDues.otherDue = cellData.userPayDetail.otherDue[key] ? Number(cellData.userPayDetail.otherDue[key]) : 0;
      }
    }
    for (const mData of monthListWithValue) {
      if (cellData[mData.name].payEnable) {
        if (cellData[mData.name].paidDone) {
          paidAmt += cellData[mData.name].amt ? Number(cellData[mData.name].amt) : 0
        } else {
          if (mData.value <= currMonthForDues) {
            userDues.monthlyFee += (isMonthFeeFree ? 0 : Number(cellData[mData.name].monthlyFee) - consessionAmt)
            userDues.busFee += Number(cellData[mData.name].busFee)
          }
        }
      }
    }

    for (let [key, value] of Object.entries(userDues)) {
      dueAmt += value
    }
    userDues.preExcessAmount = Number(preExcessAmount)
    userDues.totalDues = dueAmt - Number(preExcessAmount)
    return userDues
  }

  getOldSessionDues = (cellData) => {
    let paidAmt = 0
    let dueAmt = 0
    let userDues = {
      monthlyFee: 0,
      busFee: 0,
      prevYearAmtDue: Number(cellData.prevYearAmtDue || 0),
      preDueAmount: Number(cellData.preDueAmount || 0),
      halfExamFee: 0,
      annualExamFee: 0,
      reAdmissionFee: 0,
      preExcessAmount: 0, // minus this amount
      otherDue: 0,
      totalDues: 0
    };

    const preExcessAmount = cellData.preExcessAmount

    const feeData = this.state.monthlyFeeList.find(data => data.className === cellData.userPayDetail.class)
    const isOtherPay = cellData.userPayDetail && cellData.userPayDetail.other && cellData.userPayDetail.other.length > 0 ? true : false
    const isAnnualExamFeeNotPaid = isOtherPay ? !cellData.userPayDetail.other.some(data => data.name === 'ANNUAL EXAM') : true
    const isHalfExamFeeNotPaid = isOtherPay ? !cellData.userPayDetail.other.some(data => data.name === 'HALF YEARLY EXAM') : true
    if (cellData.sData.userInfo.admissionDate) {
      const admissionDate = new Date(cellData.sData.userInfo.admissionDate);
      const admissionMonthIndex = admissionDate.getFinancialMonthIndex();
      const admissionSession = getAdmissionSession(cellData.sData.userInfo.admissionDate);
      const isCurrentSession = isAdmissionInCurrentSession(admissionSession, this.state.selectedSession);
      if (isCurrentSession) {
        if (admissionMonthIndex < HalfYearlyMonthIndex && isHalfExamFeeNotPaid) {
          userDues.halfExamFee = addExamFees(feeData, false, true)
        }
        if (admissionMonthIndex < AnualExamMonthIndex && isAnnualExamFeeNotPaid) {
          userDues.annualExamFee = addExamFees(feeData, true, false)
        }
      } else {
        if (isHalfExamFeeNotPaid) {
          userDues.halfExamFee = addExamFees(feeData, false, true)
        }
        if (isAnnualExamFeeNotPaid) {
          userDues.annualExamFee = addExamFees(feeData, true, false)
        }
      }
    } else {
      if (isHalfExamFeeNotPaid) {
        userDues.halfExamFee = addExamFees(feeData, false, true)
      }
      if (isAnnualExamFeeNotPaid) {
        userDues.annualExamFee = addExamFees(feeData, true, false)
      }
    }

    if (cellData.userPayDetail && cellData.userPayDetail.otherDue) {
      for (const key in cellData.userPayDetail.otherDue) {
        userDues.otherDue = cellData.userPayDetail.otherDue[key] ? Number(cellData.userPayDetail.otherDue[key]) : 0;
      }
    }
    for (const mData of monthListWithValue) {
      if (cellData[mData.name].payEnable) {
        if (cellData[mData.name].paidDone) {
          paidAmt += cellData[mData.name].amt ? Number(cellData[mData.name].amt) : 0
        } else {
          if (mData.value <= 12) {
            userDues.monthlyFee += Number(cellData[mData.name].monthlyFee)
            userDues.busFee += Number(cellData[mData.name].busFee)
          }
        }
      }
    }

    for (let [key, value] of Object.entries(userDues)) {
      dueAmt += value
    }
    userDues.preExcessAmount = Number(preExcessAmount)
    userDues.totalDues = dueAmt - Number(preExcessAmount)
    return userDues
  }

  examPayModel = (cellData, examName) => {
    const feeData = this.state.monthlyFeeList.find(data => data.className === this.state.selectedClass)
    let examFeeAmt = 0;
    const examFeeMap = {
      "ANNUAL EXAM": feeData?.annualExamFee,
      "HALF YEARLY EXAM": feeData?.halfExamFee,
    }

    if (examName && examFeeMap[examName]) {
      examFeeAmt = Number(examFeeMap[examName]);
    }

    this.setState({
      examName: examName,
      selectedUser: cellData.sData,
      userPayDetail: cellData.userPayDetail,
      exmaPayModalShow: true,
      payList: [
        {
          // payModeId:'Cash',
          amount: examFeeAmt
        }]
    })
  }

  closeExamPayModal = () => {
    this.setState({
      examName: "",
      selectedUser: {},
      userPayDetail: {},
      exmaPayModalShow: false,
      payList: [{ payModeId: 'Cash', amount: 0 }],
    })
  }
  closeOtherPayModal = () => {
    this.setState({
      selectedUser: {},
      selectedCell: {},
      userPayDetail: {},
      otherPayModal: false,
      payList: [{ payModeId: 'Cash', amount: 0 }],
    })
  }

  calculteWidth = () => {
    return this.state.selectedSession && this.state.selectedSession === currentSession() ? 58 : 80
  }

  data_from_note_compo = (data) => {
    if (data && data.success === true) {
      this.getAllPaymentDetail()
      toast["success"](data.message)
    } else {
      toast["error"](data.message ? data.message : "Notes not added")
    }
  }
  // Security: MutationObserver forces type back to 'password' if changed via DevTools
  setPasswordInputRef = (el) => {
    if (el) {
      el.type = 'password'
      if (this._passwordObserver) {
        this._passwordObserver.disconnect()
      }
      this._passwordObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'type' && el.type !== 'password') {
            el.type = 'password'
          }
        })
      })
      this._passwordObserver.observe(el, { attributes: true, attributeFilter: ['type'] })
    }
  }

  fullDetailofDues = (cellData) => {
    this.setState({
      fullDetailofDuesModal: true,
      selectedCell: cellData
    })
  }

  closeFullDetailDues = () => {
    this.setState({
      fullDetailofDuesModal: false,
      selectedCell: {}
    })
  }

  updateDeductionAmtHandler = (amount) => {
    const previousDeductionAmt = this.state.selectedCell.userPayDetail.deductionAmt || 0
    const isDeductionAmtUpdated = previousDeductionAmt !== amount
    this.setState({
      deductionAmount: Number(amount),
      isDeductionAmtUpdated: isDeductionAmtUpdated
    })
  }

  render() {
    const {
      selectedUser,
      busRouteFareList,
      payList,
      excessAmount,
      dueAmount,
      paidAmount,
      totalAmount,
      totalGrandAmount,
      preDueAmount,
      preExcessAmount,
      submittedDateError,
      payOptionList,
      paymentRecieverUserList,
      allStudentUserIdList,
      selectedUserId,
      otherPaymentList,
      otherPaymentListWithMonth,
      totalOtherPayAmount,
      dueOtherPayAmount,
      selectedCell
    } = this.state

    const columns = [
      {
        Header: "Full Name",
        accessor: "userInfo.fullName",
        width: 150,
        Cell: cell => (
          <span style={{ cursor: 'pointer' }} onClick={() => this.locationRedirect(cell.original.sData)}>
            {`${cell.original.sData.userInfo.fullName} (${cell.original.sData.userInfo.userId})`}
          </span>
        )
      },
      ...monthList.map((monthName) => {
        return {
          Header: () => <div style={{ textAlign: "center", textTransform: 'uppercase' }}>{monthName}</div>,
          //accessor: "userInfo.fullName",
          width: 44,
          Cell: cell => {
            if (cell.original[monthName].payEnable) {
              const userPayDetail = cell.original.userPayDetail
              const amt = cell.original[monthName].amt
              const preDueAmount = cell.original.preDueAmount
              const preExcessAmount = cell.original.preExcessAmount

              return (
                <div style={{ cursor: `${!(amt > 0) ? 'pointer' : ''}`, textAlign: "center" }} onClick={!(amt > 0) ? () => this.getCellProps(cell.original, monthName, preDueAmount, preExcessAmount, userPayDetail) : undefined}>
                  {this.amtShow(amt)}
                </div>
              )
            } else {
              return (
                <div style={{ textAlign: "center", color: 'GrayText' }} >
                  ###
                </div>
              )
            }
          }
        }
      }),
      {
        Header: () => <>
          <span>Em1</span>
          <br />
          <span>Fee</span>
        </>,
        //accessor: "userInfo.fullName",
        width: 42,
        Cell: cell => {
          const examName = 'HALF YEARLY EXAM'
          const examAmtData = (cell?.original?.userPayDetail?.other || []).find(data => data.name === examName)
          const examAmt = examAmtData && examAmtData.amount ? Number(examAmtData.amount) : 0
          return (
            <div style={{ cursor: `${!(examAmt > 0) ? 'pointer' : ''}`, textAlign: "center" }} onClick={!(examAmt > 0) ? () => this.examPayModel(cell.original, examName) : undefined}>
              {examAmt}
            </div>
          )
        }
      },
      {
        Header: () => <>
          <span>Em2</span>
          <br />
          <span>Fee</span>
        </>,
        //accessor: "userInfo.fullName",
        width: 42,
        Cell: cell => {
          const examName = 'ANNUAL EXAM'
          const examAmtData = (cell?.original?.userPayDetail?.other || []).find(data => data.name === examName)
          const examAmt = examAmtData && examAmtData.amount ? Number(examAmtData.amount) : 0
          return (
            <div style={{ cursor: `${!(examAmt > 0) ? 'pointer' : ''}`, textAlign: "center" }} onClick={!(examAmt > 0) ? () => this.examPayModel(cell.original, examName) : undefined}>
              {examAmt}
            </div>
          )
        }
      },
      {
        Header: () => <>
          <span>Re-</span>
          <br />
          <span>Adm</span>
        </>,
        //accessor: "userInfo.fullName",
        width: 40,
        Cell: cell => {
          const isReadmissionCharge = this.shouldApplyReadmissionCharge(cell.original.sData, currentSession());
          const reAdmUp = 'reAdmissionUpper'
          const reAdmUn = 'reAdmissionUnder'
          const reAdmissionData = cell.original && cell.original.userPayDetail && cell.original.userPayDetail.other && cell.original.userPayDetail.other.length > 0 && cell.original.userPayDetail.other.find(data => (data.name == reAdmUp || data.name == reAdmUn))
          const reAdmissionAmt = reAdmissionData && reAdmissionData.amount ? Number(reAdmissionData.amount) : 0
          if (isReadmissionCharge) {
            return (
              <div
                style={{ cursor: `${!(reAdmissionAmt > 0) ? 'pointer' : ''}`, textAlign: "center" }} onClick={!(reAdmissionAmt > 0) ? () => this.actionTogle(cell.original, 'reAdmission') : undefined}
              >
                {reAdmissionAmt}
              </div>
            )
          } else {
            return (<div style={{ textAlign: "center", color: 'GrayText' }} >### </div>)
          }
        }
      },
      {
        Header: <>
          <span>Back</span>
          <br />
          <span>Dues</span>
        </>,
        //accessor: "userInfo.fullName",
        width: 45,
        Cell: cell => {
          return <span style={cell.original.preDueAmount ? { color: "red", fontWeight: "bold" } : {}}>+{cell.original.preDueAmount}</span>
        }
      },
      {
        Header: () => <>
          <span>Extra</span>
          <br />
          <span>Amt</span>
        </>,
        //accessor: "userInfo.fullName",
        width: 45,
        Cell: cell => {

          return `-${cell.original.preExcessAmount}`
        }
      },
      {
        Header: () => <>
          <span>{(this.state.selectedSession && this.state.selectedSession === currentSession()) ? 'Dues' : 'March Dues'}</span>
          <br />
          <span style={{ textTransform: 'capitalize' }}>{(this.state.selectedSession && this.state.selectedSession === currentSession()) ? monthListWithValue.find(data => data.value === currMonthForDues).name : `(${this.state.selectedSession})`}</span>
        </>,
        //accessor: "userInfo.fullName",
        width: this.calculteWidth(),
        Cell: cell => {
          const { totalDues = 0 } = cell.original.userDues
          return <span style={{ cursor: "pointer", fontWeight: '700' }} onClick={() => this.fullDetailofDues(cell.original)} >{totalDues}/-</span>
        }
      },
      {
        Header: () => <>
          <span>Prev</span>
          <br />
          <span>Year</span>
        </>,
        //accessor: "userInfo.fullName",
        width: 50,
        show: (this.state.selectedSession && this.state.selectedSession === currentSession()) ? true : false,
        Cell: cell => {
          //()=> window.open("someLink", "_blank")
          return <span style={{ cursor: 'pointer' }} onClick={() => this.handleSelectUserId(cell.original.sData, previousSession())}>{cell.original.prevYearAmtDue}/-</span>
          //return  <span>{cell.original.prevYearAmtDue}/-</span>
        }
      },
      {
        Header: "Action",
        accessor: "action",
        width: 180,
        //show:USER && (USER.userInfo.roleName==='TOPADMIN' || USER.userInfo.roleName==='ADMIN')? true:false,
        Cell: cell => {
          return (
            <Row style={{ marginLeft: "0.1rem", marginTop: "0px" }}>
              {USER && USER.userInfo.roleName === 'TOPADMIN' &&
                <button title='Delete' id={'delete'}
                  style={{ color: "red" }}
                  className="no-decoration-button"
                  onClick={e => this.actionTogle(cell.original, 'deletePayment')}>
                  <i className=" mdi mdi-delete mdi-18px"></i>
                </button>
              }
              <button title='Other Payment' id={'OtherPayment'}
                style={{ color: "green" }}
                className="no-decoration-button"
                onClick={e => this.actionTogle(cell.original, 'otherPayment')}>
                <i className="mdi mdi-cash-multiple mdi-18px"></i>
              </button>
              {"  "}
              <button title='Detail' id={'VeiwDetail'}
                style={{ color: "blue" }}
                className="no-decoration-button"
                onClick={e => this.actionTogle(cell.original, 'VeiwDetail')}
              >
                <i className="mdi mdi-receipt mdi-18px"></i>
              </button>
              <button title='Contact' id={'contact'}
                style={{ color: "green" }}
                className="no-decoration-button"
                onClick={e => this.actionTogle(cell.original, 'contact')}
              >
                <i className="mdi mdi-phone mdi-18px"></i>
              </button>

              <button title='Setting' id={'paySetting'}
                style={{ color: "#e61d1dff" }}
                className="no-decoration-button"
                onClick={e => this.actionTogle(cell.original, 'paySetting')}
              >
                <i className="mdi mdi-brightness-7 mdi-18px"></i>
              </button>

              {/* <button title='Dues Message' id={'duesMessage'}
                   style={{color: "red"}}
                   className="no-decoration-button" 
                    onClick={(e)=>this.actionTogle(cell.original, 'dueMessage')}
                    >
                      <i className="mdi mdi-near-me mdi-18px"></i>
                  </button> */}
              {/* <button title='Dues Message' id={'duesMessage'}
                   style={{color: "red"}}
                   className="no-decoration-button" 
                    onClick={(e)=>this.actionTogle(cell.original, 'dueMessage')}
                    >
                      <i className="mdi mdi-near-me mdi-18px"></i>
                  </button> */}
              <button title='Add Note' id={'addNote'}
                style={{ color: cell.original.sData && cell.original.sData.userInfo && cell.original.sData.userInfo.notes && cell.original.sData.userInfo.notes.length > 0 ? "blue" : 'grey' }}
                className="no-decoration-button"
                //className="mb-2 badge" 
                onClick={e => this.actionTogle(cell.original, 'addNoteAction')}
              >
                <i className="mdi mdi mdi-note-text mdi-18px"></i>
              </button>
            </Row>
          )
        }
      }
    ];


    const monthlyInvoiceColumn = [
      {
        Header: 'Month Name',
        accessor: 'Month Name',
        width: 88,
        Cell: (cell) => {
          if (cell.original.invoiceInfo.feeList) {
            return cell.original.invoiceInfo.feeList.map((data, index) => {
              return <div key={'month_' + index} className="py-1">
                {data.month.toUpperCase()}
                {(index !== cell.original.invoiceInfo.feeList.length - 1) ? <hr className="mt-1 mb-0"></hr> : ''}
              </div>
            })
          } else {
            return <div className="py-1"></div>
          }
        }
      },
      {
        Header: 'Month Fee',
        accessor: 'Month Fee',
        width: 75,
        Cell: (cell) => {
          if (cell.original.invoiceInfo.feeList) {
            return cell.original.invoiceInfo.feeList.map((data, index) => {
              return <div key={'monthFee_' + index} className="py-1">
                {data.monthlyFee}
                {(index !== cell.original.invoiceInfo.feeList.length - 1) ? <hr className="mt-1 mb-0"></hr> : ''}
              </div>
            })
          } else {
            return <div className="py-1"></div>
          }
        }
      },
      {
        Header: 'Bus Fee',
        accessor: 'Bus Fee',
        width: 60,
        Cell: (cell) => {
          if (cell.original.invoiceInfo.feeList) {
            return cell.original.invoiceInfo.feeList.map((data, index) => {
              return <div key={'busFee_' + index} className="py-1">
                {data.busFee}
                {(index !== cell.original.invoiceInfo.feeList.length - 1) ? <hr className="mt-1 mb-0"></hr> : ''}
              </div>
            })
          } else {
            return <div className="py-1"></div>
          }
        }
      },
      {
        Header: 'Other Fee',
        accessor: 'Other Fee',
        width: 72,
        Cell: (cell) => {
          const { userOtherInvoice } = this.state

          if (userOtherInvoice?.length > 0) {
            const otherFeeListData = userOtherInvoice.find(data => data.invoiceId === cell.original.invoiceId)
            if (otherFeeListData) {
              const otherFeeSum = otherFeeListData.invoiceInfo.otherFeeList.reduce((sum, curr) => sum + curr.amount, 0)
              return <div className="py-1">{otherFeeSum}</div>
            }
            return <div className="py-1">-</div>

          }
          return <div className="py-1">-</div>
        }
      },
      {
        Header: 'Inv No',
        accessor: 'invoiceId',
        width: 60,
      },
      {
        Header: 'Rec.No.',
        accessor: 'invoiceInfo.receiptNumber',
        width: 58,
      },
      {
        Header: "Date",
        accessor: "date",
        width: 72,
        Cell: (cell) => {
          return cell.original.invoiceInfo.submittedDate ? new Date(cell.original.invoiceInfo.submittedDate).toLocaleDateString("en-GB") : ''
        }
      },
      {
        Header: "concession",
        accessor: "concession",
        width: 78,
        Cell: (cell) => {
          return <div className="text-center">-{cell.original.invoiceInfo.concession}</div>
        }
      },
      {
        Header: "Total Amt",
        accessor: "Total Amount",
        width: 70,
        Cell: (cell) => {
          return <div className="text-center">{cell.original.invoiceInfo.totalAmount && parseInt(cell.original.invoiceInfo.totalAmount) > 0 ? parseInt(cell.original.invoiceInfo.totalAmount) : cell.original.invoiceInfo.feeList && cell.original.invoiceInfo.feeList.reduce((sum, curr) => sum + Number(curr.monthlyFee) + Number(curr.busFee), 0)}</div>
        }
      },
      {
        Header: "Dues",
        accessor: "invoiceInfo.dueAmount",
        width: 50,
        Cell: (cell) => {
          return <div className="text-center">-{cell.original.invoiceInfo.dueAmount}</div>
        }
      },
      {
        Header: "Ex Amt", //Excess Amount
        accessor: "invoiceInfo.excessAmount",
        width: 60,
        Cell: (cell) => {
          return <div className="text-center">+{cell.original.invoiceInfo.excessAmount}</div>
        }
      },
      {
        Header: "Late Fee",
        //accessor: "invoiceInfo.excessAmount",
        width: 65,
        Cell: (cell) => {
          return <div className="text-center">{cell.original.invoiceInfo.fineAmount}</div>
        }
      },
      {
        Header: "Paid Amt",
        accessor: "Paid Amount",
        width: 70,
        Cell: (cell) => {
          return <span style={{ fontWeight: 'bold' }}>{cell.original.amount}/-</span>
        }
      },
      {
        Header: "Reciever Name",
        accessor: "Reciever Name",
        width: 130,
        Cell: (cell) => {
          const paymentRecieverId = cell.original.invoiceInfo.paymentRecieverId
          const paymentRecieverData = paymentRecieverId ? paymentRecieverUserList.find(it => it._id.toString() === paymentRecieverId) : {}
          if (paymentRecieverId) {
            return paymentRecieverData && paymentRecieverData.userInfo ? paymentRecieverData.userInfo.fullName : 'Not Found'
          } else {
            return ''
          }
        }
      },
      {
        Header: "Action",
        //accessor: "userInfo.class",
        //width: 50,
        Cell: (cell) => {
          return (
            <Row style={{ marginLeft: "0.1rem", marginTop: "0px" }}>
              {cell.original.invoiceId &&
                (
                  <button title='Detail' id={'detail'}
                    className="no-decoration-button"
                    style={{ color: "#2c47ddff" }}
                    onClick={e => this.downloadPayDetail(cell.original.invoiceId)}
                  >
                    <i className="mdi mdi-download mdi-18px"></i>
                  </button>
                )
              }
              {USER && USER.userInfo && USER.userInfo.roleName && USER.userInfo.roleName === 'TOPADMIN' &&
                <button title='Delete' id={'deleteTx'}
                  className="no-decoration-button"
                  style={{ color: "#e61d1dff" }}
                  onClick={e => this.deleteTransactionByInvoiceId(cell.original.invoiceId)}
                >
                  <i className="mdi mdi-delete mdi-18px"></i>
                </button>
              }
              {cell.original && cell.original.invoiceInfo && cell.original.invoiceInfo.notes &&
                (<button title='Detail' id={'detail'}
                  className="no-decoration-button"
                  onClick={e => this.noteDetail(cell.original)}
                >
                  <i className="mdi mdi-information-outline mdi-18px"></i>
                </button>)
              }
            </Row>
          )
        }
      },
    ]
    const otherInvoiceColumn = [
      {
        Header: 'Name',
        accessor: 'Name',
        width: 225,
        Cell: (cell) => {
          if (cell.original.invoiceInfo.otherFeeList) {
            return cell.original.invoiceInfo.otherFeeList.map((data, index) => {
              return <div key={data.name + index} className="py-1">
                {data.name.toUpperCase()}{`(${data.amount}/-)`}
                {(index !== cell.original.invoiceInfo.otherFeeList.length - 1) ? <hr className="mt-1 mb-0"></hr> : ''}
              </div>
            })
          } else {
            return <div className="py-1"></div>
          }
        }
      },
      {
        Header: 'Invoice No',
        accessor: 'invoiceId',
        width: 75,
      },
      {
        Header: 'Rec.No.',
        accessor: 'invoiceInfo.receiptNumber',
        width: 58,
      },
      {
        Header: "Date",
        accessor: "date",
        width: 72,
        Cell: (cell) => {
          return cell.original.invoiceInfo.submittedDate ? new Date(cell.original.invoiceInfo.submittedDate).toLocaleDateString("en-GB") : ''
        }
      },
      {
        Header: "Total Amt",
        accessor: "Total Amount",
        width: 75,
        Cell: (cell) => {
          if (cell.original.invoiceInfo.submitType !== 'MONTHLY') {
            return <div className="text-center">{cell.original.invoiceInfo.totalAmount}/-</div>
          }
          return <div className="text-center">-</div>
        }
      },
      {
        Header: "Concession",
        accessor: "concession",
        width: 78,
        Cell: (cell) => {
          if (cell.original.invoiceInfo.submitType !== 'MONTHLY') {
            return cell.original.invoiceInfo.concession ? <div className="text-center">{cell.original.invoiceInfo.concession}/-</div> : ''
          }
          return <div className="text-center">-</div>
        }
      },
      {
        Header: "Dues",
        accessor: "invoiceInfo.dueAmount",
        width: 110,
        Cell: (cell) => {
          if (cell.original.invoiceInfo.submitType !== 'MONTHLY') {
            return cell.original.invoiceInfo.dueAmount ? <div className="text-center">{cell.original.invoiceInfo.dueAmount}{cell.original.invoiceInfo.dueFor ? (<span><br />{cell.original.invoiceInfo.dueFor.toUpperCase()}</span>) : ''}</div> : ''
          }
          return <div className="text-center">-</div>
        }
      },
      {
        Header: "Paid Amount",
        accessor: "Paid Amount",
        width: 90,
        Cell: (cell) => {
          if (cell.original.invoiceInfo.submitType !== 'MONTHLY') {
            if (cell.original.invoiceInfo.otherFeeList) {
              return <span style={{ fontWeight: 'bold' }}>{cell.original.invoiceInfo.paidAmount}/-</span>

            } else {
              return <div className="py-1"></div>
            }
          }
          return <div className="text-center">-</div>
        }
      },
      {
        Header: "Reciever Name",
        accessor: "Reciever Name",
        width: 140,
        Cell: (cell) => {
          const paymentRecieverId = cell.original.invoiceInfo.paymentRecieverId
          const paymentRecieverData = paymentRecieverId ? paymentRecieverUserList.find(it => it._id.toString() === paymentRecieverId) : {}
          if (paymentRecieverId) {
            return paymentRecieverData && paymentRecieverData.userInfo ? paymentRecieverData.userInfo.fullName : 'Not Found'
          } else {
            return ''
          }
        }
      },
      {
        Header: "Action",
        //accessor: "userInfo.class",
        //width: 50,
        Cell: (cell) => {
          return (
            <Row style={{ marginLeft: "0.1rem", marginTop: "0px" }}>
              {cell.original.invoiceId &&
                (
                  <button title='Detail' id={'detail'}
                    className="no-decoration-button"
                    style={{ color: "#2c47ddff" }}
                    onClick={e => this.downloadPayDetail(cell.original.invoiceId)}
                  >
                    <i className="mdi mdi-download mdi-18px"></i>
                  </button>
                )
              }
              {USER && USER.userInfo && USER.userInfo.roleName && USER.userInfo.roleName === 'TOPADMIN' &&
                <button title='Delete' id={'deleteTx'}
                  style={{ color: "#e61d1dff" }}
                  className="no-decoration-button"
                  onClick={e => this.deleteTransactionByInvoiceId(cell.original.invoiceId)}
                >
                  <i className="mdi mdi-delete mdi-18px"></i>
                </button>
              }
              {cell.original && cell.original.invoiceInfo && cell.original.invoiceInfo.notes &&
                (
                  <button title='Detail' id={'detail'}
                    className="no-decoration-button"
                    onClick={e => this.noteDetail(cell.original)}
                  >
                    <i className="mdi mdi-information-outline mdi-18px"></i>
                  </button>
                )
              }
            </Row>
          )
        }
      },
    ]

    return (
      <div>
        <BlockUi tag="div" blocking={this.state.loading} className="block-overlay-dark" loader={<Spinner />}>
          <div className="row">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  <p className="card-title">All Students Payment Report <span style={{ color: 'red' }}> ({this.state.selectedSession})</span></p>
                  <span className="card-title2">Total Student Count: {this.state.allPayDetail.length}
                    {(currMonthForDues >= 5) && (
                    <ScrollingText
                      message={(currMonthForDues === 11 || currMonthForDues === 12) ? "Note: Half Yearly and Annual Exam Fee Applicable" : currMonthForDues >= 5 ? "Note: Half Yearly Exam Fee Applicable" : ''}
                      speed={25}
                      textColor={(currMonthForDues === 11 || currMonthForDues === 12) ? "red" : 'blue'}
                      //backgroundColor="#333"
                      fontSize="0.7rem"
                      // fontWeight="bold"
                      height="0.8rem"
                      emoji="👉"
                      emojiPosition="start"
                      //emojiColor="green"
                      emojiAnimation="wave"
                    />
                    )}
                  </span>

                  <Row>
                    <Col>
                      <AvForm>
                        <AvInput tag={CustomInput} id="directPrint1" type="checkbox" name="directPrint"
                          label={<span style={{ color: "green" }}>Print On</span>}
                          checked={this.state.isPrint}
                          onChange={() => this.setState({ isPrint: !this.state.isPrint })}
                        />
                      </AvForm>
                    </Col>
                    <Col>
                      <AvForm>
                        <button className="no-decoration-button" onClick={() => this.calculateAllDues()}>
                          Total Dues : {this.state.loadingCal ? (
                            <>Loading...</>
                          ) : (
                            this.state.totalDuesOfClass !== null && <>{formatToIndianCurrency(this.state.totalDuesOfClass)}</>
                          )}
                        </button>
                      </AvForm>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={3} style={{ marginRight: '-2rem' }} >
                      <Form.Group>
                        {/* <label>Small input</label> */}
                        <Form.Control type="text" className="form-control"
                          placeholder="Search by name, id, phone number, etc." aria-label="Username"
                          value={this.state.inputSearch ? this.state.inputSearch : ''}
                          onChange={this.handleSearch}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2} style={{ marginRight: '-2rem' }} >
                      <Form.Group>
                        {/* <label htmlFor="exampleFormControlSelect3">Small select</label> */}
                        <select className="form-control form-control-sm" id="exampleFormControlSelect3"
                          onChange={this.handleClass}
                          value={this.state.selectedClass ? this.state.selectedClass : ''}
                        >
                          <option value=''>Select Class</option>
                          {classList.map((data, index) =>
                            <option key={index} value={data}> {data}</option>
                          )}
                        </select>
                      </Form.Group>
                    </Col>
                    <Col md={2} style={{ marginRight: '-2rem' }}>
                      <Form.Group>
                        {/* <label htmlFor="exampleFormControlSelect3">Small select</label> */}
                        <select className="form-control form-control-sm" id="exampleFormControlSelect3"
                          onChange={this.handleSession}
                          value={this.state.selectedSession ? this.state.selectedSession : ''}
                        >
                          <option value=''>Seletc Session</option>
                          {sessionList.map((data, index) =>
                            <option key={index} value={data}> {data}</option>
                          )}
                        </select>
                      </Form.Group>
                    </Col>
                    <Col md={2} style={{ marginRight: '-2rem' }}>
                      {/* <Form.Group> */}
                      <Select
                        value={selectedUserId ? allStudentUserIdList.filter((data) => data.value === selectedUserId) : ''}
                        //isClearable
                        onChange={(e) => this.handleUserIdChange(e)}
                        options={allStudentUserIdList}
                        placeholder="User Id"
                        //className="form-control"
                        //isSearchable
                        unstyled
                        //styles={{"display": "block","marginLeft": "9.5px",'float':'right',menu: provided => ({ ...provided, zIndex: 999999 })}}
                        maxMenuHeight={200}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            minHeight: '34px',
                            fontSize: '13px',
                          }),
                          dropdownIndicator: (base) => ({
                            ...base,
                            paddingTop: 0,
                            paddingBottom: 0,
                          }),
                          menuList: (base) => ({
                            ...base,
                            fontSize: '12px',
                          }),
                          menu: provided => ({ ...provided, zIndex: 9999 })
                        }}
                      />
                      {/* </Form.Group> */}
                    </Col>
                    {/* <Col md={3} style={{marginRight:'-2rem'}}>
                  <Select 
                    value={selectedPhoneNo?allStudentPhoneList.filter((data)=>data.value===selectedPhoneNo):''}
                    //isClearable
                    onChange={(e) => this.handlePhoneSearch(e)}
                    options={allStudentPhoneList}
                    placeholder="Phone number"
                    //className="form-control"
                    //isSearchable
                    unstyled
                    //styles={{"display": "block","marginLeft": "9.5px",'float':'right',menu: provided => ({ ...provided, zIndex: 999999 })}}
                    maxMenuHeight={200}
                    styles={{
                      control: (baseStyles, state) => ({
                          ...baseStyles,
                          minHeight: '34px',
                          fontSize: '13px',
                      }),
                      dropdownIndicator: (base) => ({
                          ...base,
                          paddingTop: 0,
                          paddingBottom: 0,
                      }),
                      menuList: (base) => ({
                          ...base,
                          fontSize: '12px',
                      }),
                    }}
                   />
               
              </Col> */}
                    <Col md={2} style={{ marginRight: '-2rem' }}>
                      <Form.Group>
                        <Button className="btn btn-warning btn-sm" style={{ fontWeight: "90", color: "black" }}
                          onClick={this.clearFilter}
                        >Clear Filter</Button>
                      </Form.Group>
                    </Col>
                    {/* {USER && USER.userInfo && USER.userInfo.roleName=='TOPADMIN' &&
              <Col md={2}>
              <Form.Group>
                <Button className="btn btn-warning btn-sm" style={{fontWeight:"90", color:"black"}}
                //disabled={!this.state.selectedClass}
                onClick={this.generateAdmitCard}
                >Download Admit Card</Button>
                 </Form.Group>
              </Col> } */}

                    <Col md={3} style={{ marginRight: '-2rem' }}>
                      <Form.Group>
                        <Button className="btn btn-warning btn-sm" style={{ fontWeight: "90", color: "black" }}
                          disabled={this.state.allPayDetail.length === 0}
                          onClick={this.exportDuesCSV}
                        >Download Dues Info</Button>
                      </Form.Group>
                    </Col>
                  </Row>
                  <ReactTable
                    data={this.state.allPayDetail}
                    //className='-striped -highlight'
                    className='-highlight'
                    columns={columns}
                    //defaultSorted={[{ id: "created", desc: true }]}
                    pageSize={10}
                    showPageSizeOptions={false}
                    showPageJump={false}
                    getTrProps={this.getTrProps}
                  // getTheadThProps={(state, rowInfo, column, instance) => {
                  //   return {
                  //     onClick: (e, handleOriginal) => {

                  //       if(column && column.Header && column.Header.toLowerCase()==='class'){
                  //           this.sortData('Class')
                  //       }
                  //       // if(column.Header.toLocaleLowerCase()==='email'){
                  //       //     this.sortData('email')
                  //       // }
                  //       // if(column.Header.toLocaleLowerCase()==='logged in user'){
                  //       //     this.sortData('user')
                  //       // }
                  //       // if(column.Header.toLocaleLowerCase()==='status'){
                  //       //     this.sortData('status')
                  //       // }
                  //     }
                  //   }
                  // }}
                  />
                </div>
              </div>
            </div>
          </div>
        </BlockUi>

        <Modal
          show={this.state.paymentModal}
          onHide={this.handleClose}
          size={'lg'}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ marginBottom: '-2rem' }}>Monthly Payment (<span style={{ color: 'red' }}>{this.state.selectedSession}</span>)
              <br />
              <small>{selectedUser?.userInfo ? `${selectedUser.userInfo.fullName} (${this.state.selectedClass ? this.state.selectedClass : selectedUser.userInfo.class})` : ''}({selectedUser?.userInfo && selectedUser.userInfo.fatherName})({selectedUser.userInfo && selectedUser.userInfo.motherName}) Ledger PNo.:{this.state.userPayDetail?.paymentLedgerPage}</small>

            </Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <BlockUi tag="div" blocking={this.state.loading4} className="block-overlay-dark" loader={<Spinner />}>
              <div className="card">
                <div className="card-body">
                  <AvForm onValidSubmit={(error, values) => this.handlePaymentSubmit(error, values, 'MONTHLY')}>
                    <Row>
                      <Col xs={12} sm={6} md={6} lg={3} >
                        <AvField type="select" name="paymentRecieverId" label="Select Payment Reciever"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: 'This field is required.'
                            }
                          }}
                        >
                          <option key='choose_pay_01' value=''>Choose Payment Reciever</option>
                          {paymentRecieverUserList.length > 0 && paymentRecieverUserList.map((data, index) => { return (<option key={'pay' + index} value={data._id} style={{ color: "black" }}>{data.userInfo.fullName}</option>) })}
                        </AvField>
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={3}>

                        <label style={{ color: submittedDateError ? "red" : null, fontSize: "14px", marginBottom: "0.2rem" }}
                        >Submit Date </label>
                        <Form.Group>
                          <DatePicker
                            className={submittedDateError ? "form-control w-100 dob-border-color" : "form-control w-100"}
                            dateFormat="dd/MM/yyyy"
                            selected={this.state.submittedDate}
                            maxDate={new Date()}
                            onChange={this.handleChange}
                          />
                          {submittedDateError ? <span className="error-msg-style" style={{ marginLeft: "100px" }}>Invalid DOB </span> : null}
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={3} >
                        <AvField type="text" name="phoneNumber1" label="Phone Number1 "
                          value={selectedUser.userInfo && selectedUser.userInfo.phoneNumber1 ? selectedUser.userInfo.phoneNumber1 : ''}
                          onChange={this.onChangePhoneNumber('phoneNumber1')}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: 'This field is required.'
                            },
                            maxLength: {
                              value: 10,
                              errorMessage: 'Invalid phone number 1'
                            },
                            minLength: {
                              value: 10,
                              errorMessage: 'Invalid phone number 1'
                            },
                            pattern: {
                              value: /^[0-9]+$/,
                              errorMessage: `Invalid phone number 1.`
                            }
                          }}
                        >
                        </AvField>
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={3}>
                        <AvField type="text" name="phoneNumber2" label="Phone Number 2"
                          value={selectedUser.userInfo && selectedUser.userInfo.phoneNumber2 ? selectedUser.userInfo.phoneNumber2 : ''}
                          onChange={this.onChangePhoneNumber('phoneNumber2')}
                          validate={{
                            required: {
                              value: false,
                              errorMessage: 'This field is required.'
                            },
                            maxLength: {
                              value: 10,
                              errorMessage: 'Invalid phone number 2'
                            },
                            minLength: {
                              value: 10,
                              errorMessage: 'Invalid phone number 2'
                            },
                            pattern: {
                              value: /^[0-9]+$/,
                              errorMessage: `Invalid phone number 2`
                            }
                          }}
                        >
                        </AvField>
                      </Col>
                    </Row>
                    {this.state.feeList.map((data, indexCount) => (
                      <React.Fragment key={'fee_' + indexCount}>
                      <Row>
                        <Col xs={12} sm={12} md={6} lg={3}>
                          <AvField type="select" name={`feeArray[${indexCount}].month`} label="Select Month"
                            disabled={data.month ? true : false}
                            onChange={(e) => this.changeMonth(e, indexCount, 'month')}
                            value={data.month}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: 'This field is required.'
                              }
                            }} >
                            <option key='choose_month' value=''>Choose Month</option>
                            {(data.month ? monthList : this.state.updateMonthList).map((data, index) => { return (<option key={'month_' + index} value={data} style={{ color: "black" }}>{_.startCase(data)}</option>) })}
                          </AvField>
                        </Col>
                        {this.state.userPayDetail && !(!!this.state.userPayDetail.feeFree) &&
                          <Col xs={12} sm={12} md={4} lg={2}>
                            <AvField name={`feeArray[${indexCount}].monthlyFee`} label="Monthly Fee" placeholder="0.00"
                              value={data.monthlyFee}
                              disabled={true}
                            />
                          </Col>
                        }
                        {this.state.userPayDetail && this.state.userPayDetail.busService &&
                          <>
                            <Col xs={12} sm={12} md={6} lg={3}>
                              <AvField type="select" name={`feeArray[${indexCount}].busRouteId`} label="Select Route"
                                disabled={true}
                                value={this.state.userPayDetail.busRouteId ? this.state.userPayDetail.busRouteId : ''}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: 'This field is required.'
                                  }
                                }} >
                                <option key='choosebus' value=''>Choose Bus Route</option>
                                {busRouteFareList.map((data, index) => { return (<option key={'bus_' + index} value={data.busRouteId} style={{ color: "black" }}>{data.route}</option>) })}
                              </AvField>
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={2}>
                              <AvField name={`feeArray[${indexCount}].busFee`} label="Bus Fee" placeholder="0.00"
                                value={data.busFee}
                                disabled={true}
                              />
                            </Col>
                          </>
                        }
                        <Col md={2} className='text-center'>
                          <label style={{ marginBottom: '2.5rem' }}>{" "}</label>
                          <button type="button" className="btn btn-sm btn-outline-light btn-rounded btn-icon"
                            onClick={() => this.removeRow(indexCount, 'feeList')}>
                            <i className="mdi mdi-minus-circle text-danger"></i>
                          </button>
                        </Col>
                      </Row>
                    </React.Fragment>))}
                    {this.state.updateMonthList && this.state.updateMonthList.length > 0 &&
                      <Col md={2} >
                        <button type="button" className="btn btn-inverse-primary btn-rounded btn-icon" onClick={() => this.addRow('feeList')}>
                          <i className="mdi mdi-plus-circle"></i>
                        </button>
                      </Col>
                    }

                    {otherPaymentListWithMonth.length > 0 ? (otherPaymentListWithMonth.map((data, indexNum) => {
                      return (
                        <React.Fragment key={'otherPayMonth_' + indexNum}>
                          <Row>
                            <Col xs={12} sm={12} md={5} lg={4} style={{ marginRight: '-1rem' }}>
                              <AvField type="select" name={`otherPaymentWithMonth[${indexNum}].payFor`} label="Select Payment For"
                                onChange={this.updateOtherPaymentWithMonthField(indexNum, 'payFor')}
                                value={data.payFor}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: 'This field is required.'
                                  }
                                }} >

                                <option value=''>Choose one</option>
                                {[...otherPaymentTypeList, ...this.state.examFeePayList].map((data, index) => {
                                  return (
                                    <option key={index + 'otherpay'} value={data.value} style={{ color: "black" }}>
                                      {data.label}
                                    </option>
                                  )
                                }
                                )}
                              </AvField>
                            </Col>
                            <Col xs={12} sm={12} md={5} lg={2} style={{ marginRight: '-2rem' }}>
                              <AvField name={`otherPaymentWithMonth[${indexNum}].amount`} label="Amount" placeholder="0.00"
                                //onKeyUp={e=> this.calculatePaymentield(e, indexNum)}
                                onChange={this.updateOtherPaymentWithMonthField(indexNum, 'amount')}
                                //disabled={ROLENAME==='ACCOUNTANT'?true:false}  
                                value={data.amount}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: 'This field is required.'
                                  },

                                  async: function (value, ctx, input, cb) {
                                    const pattern = /^[0-9]+$/
                                    if (value && !pattern.test(value)) {
                                      cb('Invalid Number')
                                    } else if (value && pattern.test(value) && !Number(value) > 0) {
                                      cb('Not valid amount')
                                    } else {
                                      cb(true)
                                    }
                                  }
                                }}
                              />
                            </Col>
                            <Col md={2} className='text-center' style={{ marginLeft: '-1rem' }}>
                              <label style={{ marginBottom: '2.5rem' }}>{" "}</label>
                              <button type="button" className="btn btn-sm btn-outline-light btn-rounded btn-icon"
                                onClick={() => this.removeRow(indexNum, 'otherPayListWithMonth')}>
                                <i className="mdi mdi-minus-circle text-danger"></i>
                              </button>
                            </Col>
                          </Row>
                        </React.Fragment>
                      )
                    })) : 'Add Other Payment'}

                    <Col md={2} >
                      <button type="button" className="btn btn-inverse-success btn-rounded btn-icon" onClick={() => this.addRow('otherPayListWithMonth')}>
                        <i className="mdi mdi-plus-circle"></i>
                      </button>
                    </Col>


                    <Row>
                      <Col xs={12} sm={6} md={6} lg={3}>
                        <AvField name="fineAmount" label="Late Fee" placeholder="0.00"
                          onKeyUp={(e) => this.onAmountChange(e, 'fine')}
                          //value={!!selectedUser && selectedUser.userInfo && selectedUser.userInfo.fatherName}     
                          validate={{
                            async: function (value, ctx, input, cb) {
                              const pattern = /^[0-9]+$/
                              if (value && !pattern.test(value)) {
                                cb('Invalid Number')
                              } else {
                                cb(true)
                              }
                            }
                          }}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={3}>
                        <AvField name="concession" label="Concession" placeholder="0.00"
                          //value={this.state.userPayDetail?.deductionInfo?.amt || ''}   
                          value={this.state.concessionAmount}  
                          validate={{
                            async: function (value, ctx, input, cb) {
                              const pattern = /^[0-9]+$/
                              if (value && !pattern.test(value)) {
                                cb('Invalid Number')
                              } else {
                                if (value && Number(value) > Number(totalGrandAmount)) {
                                  cb('Invalid concession')
                                } else {
                                  cb(true)
                                }
                              }
                            }
                          }}
                          onKeyUp={(e) => this.onAmountChange(e, 'concession')}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={3}>
                        <AvField name="receiptNumber" label="Receipt Number" placeholder="000"
                          //value={!!selectedUser && selectedUser.userInfo && selectedUser.userInfo.fatherName}     
                          validate={{
                            async: function (value, ctx, input, cb) {
                              const pattern = /^[0-9]+$/
                              if (value && !pattern.test(value)) {
                                cb('Invalid Receipt Number')
                              } else {
                                cb(true)
                              }
                            }
                          }}
                        />
                      </Col>
                      <Col md={3}>
                        <AvField name="paymentLedgerPage" label="Payment Ledger P.No." placeholder="210"
                          value={this.state.userPayDetail?.paymentLedgerPage}
                          validate={{
                            required: {
                              value: false,
                              errorMessage: 'This field is required.'
                            }
                          }} />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={6} md={6} lg={3}>
                        <AvField name="dueAmount" label="Due Amount" placeholder="0.00"
                          disabled={true}
                          value={dueAmount}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={3}>
                        <AvField name="preDueAmount" label="Over-Due Amount" placeholder="0.00"
                          disabled={true}
                          value={preDueAmount}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={3}>
                        <AvField name="excessAmount" label="Excess Amount" placeholder="0.00"
                          disabled={true}
                          value={excessAmount}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={3}>
                        <AvField name="preExcessAmount" label="Over-Excess Amount" placeholder="0.00"
                          disabled={true}
                          value={preExcessAmount}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={3}>
                        <AvField name="paidAmount" label="Final Paid Amount" placeholder="0.00"
                          disabled={true}
                          value={paidAmount}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={3}>
                        <AvField name="totalAmount" label="Final Total Amount" placeholder="0.00"
                          disabled={true}
                          value={totalAmount}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={6}>
                        {payList.map((data, indexNum) => {
                          return (
                            <React.Fragment key={'payList_' + indexNum}>
                              <Row>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                  <AvField type="select" name={`payment[${indexNum}].payModeId`} label="Select Payment Mode"
                                    onChange={this.updatePaymentField(indexNum, 'payModeId')}
                                    value={data.payModeId}
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: 'This field is required.'
                                      }
                                    }} >
                                    <option key='choose01' value=''>Choose Payment Mode</option>
                                    <option key='cash01' style={{ color: "black" }} value='Cash'>Cash</option>
                                    {payOptionList.map((data, index) => {
                                      return (
                                        <option key={`pay_${index}`} value={data.payModeId || data._id} style={{ color: "black" }}>
                                          {formatPayOptionLabel(data)}
                                        </option>
                                      )
                                    }
                                    )}
                                  </AvField>
                                </Col>
                                <Col xs={12} sm={6} md={4} lg={4}>
                                  <AvField name={`payment[${indexNum}].amount`} label="Amount" placeholder="0.00"
                                    type="number"
                                    style={{ color: data.amount > 0 && Number(data.amount) === Number(totalAmount) ? "green" : "red", fontWeight:"bold" }}
                                    //inputStyle={{ color: data.amount > 0 && Number(dueAmount) === 0 ? "green" : "black", fontWeight: data.amount > 0 && Number(dueAmount) === 0 ? "bold" : "normal" }}
                                    onKeyUp={e => this.calculatePaymentField(e, indexNum)}
                                    onChange={this.updatePaymentField(indexNum, 'amount')}
                                    value={data.amount}
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: 'This field is required.'
                                      },
                                      // pattern: {
                                      //   value:  /^[a-zA-Z][a-zA-Z\s]*$/,
                                      //   errorMessage: `Invalid father name.`
                                      // }
                                      async: function (value, ctx, input, cb) {
                                        const pattern = /^[0-9]+$/
                                        if (value && !pattern.test(value)) {
                                          cb('Invalid Number')
                                        } else {
                                          cb(true)
                                        }
                                      }
                                    }}
                                  />
                                </Col>
                                <Col md={2} className='text-center'>
                                  <label style={{ marginBottom: '2.5rem' }}>{" "}</label>
                                  <button type="button" className="btn btn-sm btn-outline-light btn-rounded btn-icon"
                                    onClick={() => this.removeRow(indexNum, 'payList')}>
                                    <i className="mdi mdi-minus-circle text-danger"></i>
                                  </button>
                                </Col>
                              </Row>
                            </React.Fragment>
                          )
                        })}
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={5}>
                        <AvField name="notes" label="Add Note (If required)" placeholder=" Write note here"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={1} >
                        <button type="button" className="btn btn-inverse-primary btn-rounded btn-icon" onClick={() => this.addRow('payList')}>
                          <i className="mdi mdi-plus-circle"></i>
                        </button>
                      </Col>
                      <Col>
                        <div className="form-check">
                          <label className="form-check-label text-muted" style={{ color: "green" }}>
                            <input type="checkbox" id="directPrint3" className="form-check-input"
                              checked={this.state.isPrint}
                              onChange={() => this.setState({ isPrint: !this.state.isPrint })}
                            />
                            <i className="input-helper"></i>
                            Print On
                          </label>
                        </div>
                        {/* <AvInput tag={CustomInput} id="directPrint2" type="checkbox" name="directPrint"
                          label={<span style={{color: "green"}}>Print On</span>}
                          checked={this.state.isPrint}
                          onChange={()=>this.setState({isPrint: !this.state.isPrint})}
                        /> */}
                      </Col>
                    </Row>

                    <Row>
                      <Col className='text-center'>
                        <Button variant="secondary" onClick={this.handleClose} >Cancel</Button>
                      </Col>
                      <Col className='text-center'>
                        <Button type="submit">Submit</Button>
                      </Col>
                    </Row>
                  </AvForm>
                </div>
              </div>
            </BlockUi>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.viewPaymentDetail}
          onHide={this.handleClose}
          size={'lg'}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ marginBottom: '-2rem' }}>
              <small>{selectedUser.userInfo ? `${selectedUser.userInfo.fullName} (${selectedUser.userInfo && selectedUser.userInfo.userId}) (${this.state.selectedClass ? this.state.selectedClass : selectedUser.userInfo.class})` : ''}({selectedUser.userInfo && selectedUser.userInfo.fatherName})({selectedUser.userInfo && selectedUser.userInfo.motherName})
                Total Paid Amount:{this.state.userAllInvoice.reduce((sum, curr) => sum + Number(curr.amount), 0)}/- Ledger PNo. {selectedUser.paymentLedgerPage ? selectedUser.paymentLedgerPage : ''}</small>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <BlockUi tag="div" blocking={this.state.deleteLoading} className="block-overlay-dark" loader={<Spinner />}>
              <div className="card">
                <div className="card-body" style={{ padding: "0.5rem 0.5rem" }} >
                  <ReactTable
                    data={this.state.userMonthlyInvoice ? this.state.userMonthlyInvoice : []}
                    className='-striped -highlight'
                    //className='-highlight'
                    NoDataComponent={() => null}
                    columns={monthlyInvoiceColumn}
                    pageSize={this.state.pageSizeOfViewPayment ? this.state.pageSizeOfViewPayment : 12}
                    showPageSizeOptions={false}
                    showPageJump={false}
                    showPagination={false}
                  />
                  <ReactTable
                    data={this.state.userOtherInvoice ? this.state.userOtherInvoice : []}
                    className='-striped -highlight'
                    //className='-highlight'
                    NoDataComponent={() => null}
                    columns={otherInvoiceColumn}
                    pageSize={this.state.userOtherInvoice && this.state.userOtherInvoice.length > 0 ? this.state.userOtherInvoice.length : 1}
                    showPageSizeOptions={false}
                    showPageJump={false}
                    showPagination={false}
                  />
                </div>
                <span></span>
              </div>
            </BlockUi>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.contactModalShow}
          onHide={this.handleClose}
          //size={'lg'}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ marginBottom: '-2rem' }}>
              <small>{selectedUser.userInfo ? `${selectedUser.userInfo.fullName} (${this.state.selectedClass ? this.state.selectedClass : selectedUser.userInfo.class})` : ''}({selectedUser.userInfo && selectedUser.userInfo.fatherName})({selectedUser.userInfo && selectedUser.userInfo.motherName})</small>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <BlockUi tag="div" blocking={this.state.loading4} className="block-overlay-dark" loader={<Spinner />}>
              <div className="card">
                <div className="card-body">
                  {selectedUser && selectedUser.userInfo && selectedUser.userInfo.phoneNumber1 &&
                    <div className="card-header" ref={this.anchorRef}>
                      <a id="myAnchor" href={`tel:${selectedUser.userInfo.phoneNumber1}`} style={{ fontSize: '1.5rem' }} > <i className="mdi mdi mdi-phone mdi-24px text-success"></i>{selectedUser.userInfo.phoneNumber1}</a>
                      {/* <button onClick={()=>this.copyToClipBoard(selectedUser.userInfo.phoneNumber1)}>Copy</button> */}
                      <a title='Copy' id={'copy1'}
                        style={{
                          paddingRight: '0px',
                          paddingTop: '0px',
                          paddingBottom: '0px', cursor: 'pointer'
                        }}
                        className="mb-0 badge"
                        onClick={() => this.copyToClipBoard(selectedUser.userInfo.phoneNumber1)}
                      >
                        <i className="mdi mdi-content-paste mdi-24px"></i>
                      </a>
                    </div>
                  }
                  {selectedUser && selectedUser.userInfo && selectedUser.userInfo.phoneNumber2 &&
                    <div className="card-header">
                      <a href={`tel:${selectedUser.userInfo.phoneNumber2}`} style={{ fontSize: '1.5rem' }}> <i className="mdi mdi mdi-phone mdi-24px text-dark"></i>{selectedUser.userInfo.phoneNumber2}</a>
                      {/* <button onClick={()=>this.copyToClipBoard(selectedUser.userInfo.phoneNumber2)}>Copy</button> */}
                      <a title='Copy' id={'copy2'}
                        style={{
                          paddingRight: '0px',
                          paddingTop: '0px',
                          paddingBottom: '0px', cursor: 'pointer'
                        }}
                        className="mb-0 badge"
                        onClick={() => this.copyToClipBoard(selectedUser.userInfo.phoneNumber2)}
                      >
                        <i className="mdi mdi-content-paste mdi-24px"></i>
                      </a>
                    </div>
                  }
                  <div className="card-header" >Dues Amount: {this.state.duesAmount}/-</div>
                </div>
              </div>
            </BlockUi>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.exmaPayModalShow}
          onHide={this.closeExamPayModal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ marginBottom: '-2rem' }}> {this.state.examName} FEE (<span style={{ color: 'red' }}>{this.state.selectedSession}</span>)
              <br />
              <small>{selectedUser?.userInfo ? `${selectedUser.userInfo.fullName} (${this.state.selectedClass ? this.state.selectedClass : selectedUser.userInfo.class})` : ''}({selectedUser?.userInfo && selectedUser.userInfo.fatherName})({selectedUser?.userInfo && selectedUser.userInfo.motherName}) Ledger PNo.:{this.state.userPayDetail?.paymentLedgerPage}</small>
            </Modal.Title>

          </Modal.Header>
          <Modal.Body >
            <BlockUi tag="div" blocking={this.state.loading4} className="block-overlay-dark" loader={<Spinner />}>
              <div className="card">
                <div className="card-body">
                  <AvForm
                    onValidSubmit={(error, values) => this.handlePaymentSubmit(error, values, 'EXAM_FEE')}
                    ref={c => (this.form = c)}
                  >
                    <Row>
                      <Col>
                        <AvField type="select" name="paymentRecieverId" label="Select Payment Reciever"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: 'This field is required.'
                            }
                          }}
                        >
                          <option value=''>Choose Payment Reciever</option>
                          {paymentRecieverUserList.length > 0 && paymentRecieverUserList.map((data, index) => { return (<option key={index} value={data._id} style={{ color: "black" }}>{data.userInfo.fullName}</option>) })}
                        </AvField>
                      </Col>
                      <Col>
                        <label style={{ color: submittedDateError ? "red" : null, fontSize: "14px", marginBottom: "0.2rem" }}
                        >Submit Date </label>
                        <Form.Group>
                          <DatePicker
                            className={submittedDateError ? "form-control w-100 dob-border-color" : "form-control w-100"}
                            dateFormat="dd/MM/yyyy"
                            selected={this.state.submittedDate}
                            maxDate={new Date()}
                            onChange={this.handleChange}
                          />
                          {submittedDateError ? <span className="error-msg-style" style={{ marginLeft: "100px" }}>Invalid DOB </span> : null}
                        </Form.Group>
                      </Col>
                    </Row>

                    {payList.map((data, indexNum) => {
                      return (
                        <React.Fragment key={'payList2_' + indexNum}>
                          <Row>
                            <Col>
                              <AvField type="select" name={`payment[${indexNum}].payModeId`} label="Select Payment Mode"
                                onChange={this.updatePaymentField(indexNum, 'payModeId')}
                                value={data.payModeId}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: 'This field is required.'
                                  }
                                }} >
                                <option value=''>Choose Payment Mode</option>
                                <option style={{ color: "black" }} value='Cash'>Cash</option>
                                {payOptionList.map((data, index) => {
                                  return (
                                    <option key={index + 'pay'} value={data.payModeId || data._id} style={{ color: "black" }}>
                                      {formatPayOptionLabel(data)}
                                    </option>
                                  )
                                }
                                )}
                              </AvField>
                            </Col>
                            <Col >
                              <AvField name={`payment[${indexNum}].amount`} label="Amount" placeholder="0.00"
                                //onKeyUp={e=> this.calculatePaymentField(e, indexNum)}
                                onChange={this.updatePaymentField(indexNum, 'amount')}
                                disabled={ROLENAME === 'ACCOUNTANT' ? true : false}
                                value={data.amount}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: 'This field is required.'
                                  },
                                  // pattern: {
                                  //   value:  /^[a-zA-Z][a-zA-Z\s]*$/,
                                  //   errorMessage: `Invalid father name.`
                                  // }
                                  async: function (value, ctx, input, cb) {
                                    const pattern = /^[0-9]+$/
                                    if (value && !pattern.test(value)) {
                                      cb('Invalid Number')
                                    } else {
                                      cb(true)
                                    }
                                  }
                                }}
                              />
                            </Col>
                            {/* <Col md={2} className='text-center'>
                                <label style={{marginBottom:'2.5rem'}}>{" "}</label> 
                                  <button type="button" className="btn btn-sm btn-outline-light btn-rounded btn-icon" 
                                    onClick={()=>this.removeRow(indexNum, 'payList')}>
                                  <i className="mdi mdi-minus-circle text-danger"></i>
                                </button>
                              </Col> */}
                          </Row>
                        </React.Fragment>
                      )
                    })}
                    <Row>
                      <Col>
                        <AvField name="receiptNumber"
                          label="Receipt Number"
                          placeholder="000"
                           validate={{
                            async: function (value, ctx, input, cb) {
                              const pattern = /^[0-9]+$/
                              if (value && !pattern.test(value)) {
                                cb('Invalid Receipt Number')
                              } else {
                                cb(true)
                              }
                            }
                          }}
                        />
                      </Col>
                      <Col>
                        <AvField name="notes" label="Add Note (If required)" placeholder=" Write note here" />
                      </Col>
                      <Col>
                        <AvField name="paymentLedgerPage" label="Payment Ledger P.No." placeholder="210"
                          value={this.state.userPayDetail?.paymentLedgerPage}
                          validate={{
                            required: {
                              value: false,
                              errorMessage: 'This field is required.'
                            },
                          }} />
                      </Col>
                    </Row>
                    <Row>
                      <Col className='text-center'>
                        <Button type="submit">Submit</Button>
                      </Col>
                      <Col className='text-center'>
                        <Button variant="secondary" onClick={this.closeExamPayModal} >Cancel</Button>
                      </Col>
                    </Row>
                  </AvForm>
                </div>
              </div>
            </BlockUi>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.otherPayModal}
          onHide={this.closeOtherPayModal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ marginBottom: '-2rem' }}> Other Payment (<span style={{ color: 'red' }}>{this.state.selectedSession}</span>)
              <br />
              <small>{selectedUser?.userInfo ? `${selectedUser.userInfo.fullName} (${this.state.selectedClass ? this.state.selectedClass : selectedUser.userInfo.class})` : ''}({selectedUser?.userInfo && selectedUser.userInfo.fatherName})({selectedUser?.userInfo && selectedUser.userInfo.motherName}) Ledger PNo.:{this.state.userPayDetail?.paymentLedgerPage}</small>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <BlockUi tag="div" blocking={this.state.loading4} className="block-overlay-dark" loader={<Spinner />}>
              <div className="card">
                <div className="card-body">
                  <AvForm
                    onValidSubmit={(error, values) => this.handlePaymentSubmit(error, values, 'OTHER_PAYMENT')}
                    ref={c => (this.form = c)}
                  >
                    <Row>
                      <Col xs={12} sm={6} md={6} lg={6} style={{ marginRight: '-1rem' }}>
                        <AvField type="select" name="paymentRecieverId" label="Select Payment Reciever"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: 'This field is required.'
                            }
                          }}
                        >
                          <option value=''>Choose Payment Reciever</option>
                          {paymentRecieverUserList.length > 0 && paymentRecieverUserList.map((data, index) => { return (<option key={index} value={data._id} style={{ color: "black" }}>{data.userInfo.fullName}</option>) })}
                        </AvField>
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={6} >
                        <label style={{ color: submittedDateError ? "red" : null, fontSize: "14px", marginBottom: "0.2rem" }}
                        >Submit Date </label>
                        <Form.Group>
                          <DatePicker
                            className={submittedDateError ? "form-control w-100 dob-border-color" : "form-control w-100"}
                            dateFormat="dd/MM/yyyy"
                            selected={this.state.submittedDate}
                            maxDate={new Date()}
                            onChange={this.handleChange}
                          />
                          {submittedDateError ? <span className="error-msg-style" style={{ marginLeft: "100px" }}>Invalid DOB </span> : null}
                        </Form.Group>
                      </Col>
                    </Row>
                    {otherPaymentList.map((data, indexNum) => {
                      return (
                        <React.Fragment key={'otherPay_' + indexNum}>
                          <Row>
                            <Col xs={12} sm={6} md={6} lg={6} style={{ marginRight: '-1rem' }}>
                              <AvField type="select" name={`otherPayment[${indexNum}].payFor`} label="Select Payment For"
                                onChange={this.updateOtherPaymentField(indexNum, 'payFor')}
                                value={data.payFor}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: 'This field is required.'
                                  }
                                }} >

                                <option value=''>Choose one</option>
                                {[...otherPaymentTypeList, ...otherPaymentDuesTypeList, ...uniformSizeChartList].map((data, index) => {
                                  return (
                                    <option key={index + 'otherpay'} value={data.value} style={{ color: "black" }}>
                                      {data.label}
                                    </option>
                                  )
                                }
                                )}
                              </AvField>
                            </Col>
                            <Col xs={12} sm={6} md={5} lg={5} style={{ marginRight: '-2rem' }}>
                              <AvField name={`otherPayment[${indexNum}].amount`} label="Amount" placeholder="0.00"
                                //onKeyUp={e=> this.calculatePaymentField(e, indexNum)}
                                onChange={this.updateOtherPaymentField(indexNum, 'amount')}
                                //disabled={ROLENAME==='ACCOUNTANT'?true:false}  
                                value={data.amount}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: 'This field is required.'
                                  },
                                  // pattern: {
                                  //   value:  /^[a-zA-Z][a-zA-Z\s]*$/,
                                  //   errorMessage: `Invalid father name.`
                                  // }
                                  async: function (value, ctx, input, cb) {
                                    const pattern = /^[0-9]+$/
                                    if (value && !pattern.test(value)) {
                                      cb('Invalid Number')
                                    } else if (value && pattern.test(value) && !Number(value) > 0) {
                                      cb('Not valid amount')
                                    } else {
                                      cb(true)
                                    }
                                  }
                                }}
                              />
                            </Col>
                            <Col md={2} className='text-center' style={{ marginLeft: '-1rem' }}>
                              <label style={{ marginBottom: '2.5rem' }}>{" "}</label>
                              <button type="button" className="btn btn-sm btn-outline-light btn-rounded btn-icon"
                                onClick={() => this.removeRow(indexNum, 'otherPayList')}>
                                <i className="mdi mdi-minus-circle text-danger"></i>
                              </button>
                            </Col>
                          </Row>
                        </React.Fragment>
                      )
                    })}
                    <Row>
                      <Col md={1} >
                        <button type="button" className="btn btn-inverse-primary btn-rounded btn-icon" onClick={() => this.addRow('otherPayList')}>
                          <i className="mdi mdi-plus-circle"></i>
                        </button>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={6} md={6} lg={6} style={{ marginRight: '-1rem' }}>
                        <AvField name={'otherPayConcession'} label="Concession" placeholder="0.00"
                          //onKeyUp={e=> this.calculatePaymentField(e, indexNum)}
                          //onChange ={this.updatePaymentField(indexNum, 'amount')}
                          //disabled={true}  
                          //value={this.state.totalOtherPayAmount}     
                          validate={{
                            async: function (value, ctx, input, cb) {
                              const pattern = /^[0-9]+$/
                              if (value && !pattern.test(value)) {
                                cb('Invalid Number')
                              } else {
                                if (value && Number(value) > Number(totalOtherPayAmount)) {
                                  cb('Invalid concession')
                                } else {
                                  cb(true)
                                }
                              }
                            }
                          }}
                          onKeyUp={(e) => this.onAmountChange(e, 'otherPayConcession')}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={6} >
                        <AvField name={'totalOtherPayAmount'} label="Total Amount" placeholder="0.00"
                          //onKeyUp={e=> this.calculatePaymentField(e, indexNum)}
                          // onChange ={this.updatePaymentField(indexNum, 'amount')}
                          disabled={true}
                          value={this.state.totalOtherPayAmount}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: 'This field is required.'
                            },
                            // pattern: {
                            //   value:  /^[a-zA-Z][a-zA-Z\s]*$/,
                            //   errorMessage: `Invalid father name.`
                            // }
                            async: function (value, ctx, input, cb) {
                              const pattern = /^[0-9]+$/
                              if (value && !pattern.test(value)) {
                                cb('Invalid Number')
                              } else {
                                cb(true)
                              }
                            }
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={6} md={6} lg={6} style={{ marginRight: '-1rem' }}>
                        <AvField name={'dueOtherPay'} label="Due Amount" placeholder="0.00"
                          //onKeyUp={e=> this.calculatePaymentField(e, indexNum)}
                          //onChange ={this.updatePaymentField(indexNum, 'amount')}
                          //disabled={true}  
                          //value={this.state.totalOtherPayAmount}     
                          validate={{
                            async: function (value, ctx, input, cb) {
                              const pattern = /^[0-9]+$/
                              if (value && !pattern.test(value)) {
                                cb('Invalid Number')
                              } else {
                                if (value && Number(value) > Number(totalOtherPayAmount)) {
                                  cb('Invalid due amount')
                                } else {
                                  cb(true)
                                }
                              }
                            }
                          }}
                          onKeyUp={(e) => this.onAmountChange(e, 'dueOtherPay')}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={6} >
                        <AvField type="select" name={`dueOtherPaymentType`} label="Select Due Type"
                          //onChange ={this.updateOtherPaymentField(indexNum, 'payFor')}
                          disabled={!(this.state.dueOtherPayAmount && parseInt(this.state.dueOtherPayAmount) > 0)}
                          //value={data.payFor} 
                          validate={{
                            required: {
                              value: dueOtherPayAmount && dueOtherPayAmount > 0 ? true : false,
                              errorMessage: 'This field is required.'
                            }
                          }} >
                          <option value=''>Choose one</option>
                          {otherPaymentDuesTypeList.map((data, index) => {
                            return (
                              <option key={index + 'dueotherpay'} value={data.value} style={{ color: "black" }}>
                                {data.label}
                              </option>
                            )
                          }
                          )}
                        </AvField>
                      </Col>
                    </Row>
                    {payList.map((data, indexNum) => {
                      return (
                        <React.Fragment key={'payList3_' + indexNum}>
                          <Row>
                            <Col xs={12} sm={6} md={6} lg={6} style={{ marginRight: '-1rem' }}>
                              <AvField type="select" name={`payment[${indexNum}].payModeId`} label="Select Payment Mode"
                                onChange={this.updatePaymentField(indexNum, 'payModeId')}
                                value={data.payModeId}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: 'This field is required.'
                                  }
                                }} >
                                <option value=''>Choose Payment Mode</option>
                                <option style={{ color: "black" }} value='Cash'>Cash</option>
                                {payOptionList.map((data, index) => {
                                  return (
                                    <option key={index + 'pay'} value={data.payModeId || data._id} style={{ color: "black" }}>
                                      {formatPayOptionLabel(data)}
                                    </option>
                                  )
                                }
                                )}
                              </AvField>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={6} >
                              <AvField name={`payment[${indexNum}].amount`} label="Amount" placeholder="0.00"
                                //onKeyUp={e=> this.calculatePaymentField(e, indexNum)}
                                onChange={this.updatePaymentField(indexNum, 'amount')}
                                //disabled={ROLENAME==='ACCOUNTANT'?true:false}  
                                disabled={true}
                                value={data.amount}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: 'This field is required.'
                                  },
                                  // pattern: {
                                  //   value:  /^[a-zA-Z][a-zA-Z\s]*$/,
                                  //   errorMessage: `Invalid father name.`
                                  // }
                                  async: function (value, ctx, input, cb) {
                                    const pattern = /^[0-9]+$/
                                    if (value && !pattern.test(value)) {
                                      cb('Invalid Number')
                                    } else {
                                      cb(true)
                                    }
                                  }
                                }}
                              />
                            </Col>
                            {/* <Col md={2} className='text-center'>
                                <label style={{marginBottom:'2.5rem'}}>{" "}</label> 
                                  <button type="button" className="btn btn-sm btn-outline-light btn-rounded btn-icon" 
                                    onClick={()=>this.removeRow(indexNum, 'payList')}>
                                  <i className="mdi mdi-minus-circle text-danger"></i>
                                </button>
                              </Col> */}
                          </Row>
                        </React.Fragment>
                      )
                    })}
                    <Row>
                      <Col xs={12} sm={6} md={6} lg={6} style={{ marginRight: '-1rem' }}>
                        <AvField name="receiptNumber"
                          label="Receipt Number"
                          placeholder="000"
                          validate={{
                            async: function (value, ctx, input, cb) {
                              const pattern = /^[0-9]+$/
                              if (value && !pattern.test(value)) {
                                cb('Invalid Receipt Number')
                              } else {
                                cb(true)
                              }
                            }
                          }}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={6}>
                        <AvField name="notes" label="Add Note (If required)" placeholder=" Write note here" />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={6} md={6} lg={6}>
                        <AvField name="paymentLedgerPage" label="Payment Ledger P.No." placeholder="210"
                          value={this.state.userPayDetail?.paymentLedgerPage}
                          validate={{
                            required: {
                              value: false,
                              errorMessage: 'This field is required.'
                            },
                          }} />
                      </Col>
                    </Row>
                    <Row>
                      <Col className='text-center'>
                        <Button type="submit">Submit</Button>
                      </Col>
                      <Col className='text-center'>
                        <Button variant="secondary" onClick={this.closeOtherPayModal} >Cancel</Button>
                      </Col>
                    </Row>
                  </AvForm>
                </div>
              </div>
            </BlockUi>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.deleteModalShow}
          onHide={this.handleClose}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Are you sure to delete this payment?</Modal.Title>
          </Modal.Header>
          <Modal.Footer>
            <Button variant="primary" onClick={() => this.deletePaymentDetail()}>
              Ok
            </Button>
            <Button
              variant="secondary"
              onClick={this.handleClose}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.noteModal}
          onHide={this.handleCloseNoteModal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <small>Note Detail</small>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <div className="card">
              <div className="card-body">
                {this.state.noteData}
              </div>
            </div>
          </Modal.Body>
          {/* <Modal.Footer>
            <Button variant="primary" 
            onClick={()=>this.handleClose()}>
              Ok
            </Button>
          </Modal.Footer> */}
        </Modal>
        <Modal
          show={this.state.onlinePayModal}
          onHide={this.handleCloseNoteModal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {/* <Modal.Header closeButton>
          <Modal.Title> 
            <small>Note Detail</small>
          </Modal.Title>
          </Modal.Header> */}
          <Modal.Body >
            {/* <div className="card"> 
              <div className="card-body"> */}
            <iframe src={this.state.phonePeUrl} title="Payment" style={{ width: '100%', height: '90vh' }} />
            {/* </div>
           </div>   */}
          </Modal.Body>
          {/* <Modal.Footer>
            <Button variant="primary" 
            onClick={()=>this.handleClose()}>
              Ok
            </Button>
          </Modal.Footer> */}
        </Modal>
        <Modal
          show={this.state.addNoteModalShow}
          onHide={this.handleClose}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ marginBottom: '-2rem' }} >Add Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AddNote selectedUser={this.state.selectedUser} setDataFromNote={this.data_from_note_compo} />
          </Modal.Body>
          <Modal.Footer style={{ marginBottom: '-0.5rem', marginTop: '-1rem' }}>
            <Button className="btn btn-sm" style={{ fontWeight: "100", }}
              onClick={this.handleClose} >Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.fullDetailofDuesModal}
          onHide={this.closeFullDetailDues}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ marginBottom: '-2rem' }} >Full Detail {this.state.selectedCell?.userPayDetail?.userId}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <strong>User Dues:</strong>
            <ul style={{ margin: 0, paddingLeft: "15px" }}>
              {this.state.selectedCell.userDues && Object.entries(this.state.selectedCell?.userDues).map(([key, val]) => (
                <li key={key}>
                  {key}: <strong>{val}</strong>
                </li>
              ))}
            </ul>
            {this.state.selectedCell?.userPayDetail?.deductionInfo?.amt ? <> <strong>Note: </strong> <small>Deduction Applied  ₹{this.state.selectedCell?.userPayDetail?.deductionInfo?.amt}/pm</small> </>: null}
          </Modal.Body>
          <Modal.Footer style={{ marginBottom: '-0.5rem', marginTop: '-1rem' }}>
            <Button className="btn btn-sm" style={{ fontWeight: "100", }}
              onClick={this.closeFullDetailDues} >Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.paymentSetting}
          onHide={this.closeOtherSettingModal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ marginBottom: '-2rem' }}> Student Payment Setting  (<span style={{ color: 'red' }}>{this.state.selectedSession}</span>)
              <br />
              <small>{selectedUser.userInfo ? `${selectedUser.userInfo.fullName} (${this.state.selectedClass ? this.state.selectedClass : selectedUser.userInfo.class})` : ''}({selectedUser.userInfo && selectedUser.userInfo.fatherName})({selectedUser.userInfo && selectedUser.userInfo.motherName})</small>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <BlockUi tag="div" blocking={this.state.loading4} className="block-overlay-dark" loader={<Spinner />}>
              <div className="card">
                <div className="card-body">
                  <AvForm onValidSubmit={this.handlePaymentSettingSubmit} ref={c => (this.form = c)}>
                    <Row>
                      <Col xs={12} sm={6} md={6} lg={6} style={{ marginRight: '-1rem' }}>
                        <label></label>
                        <CustomInput
                          type="checkbox"
                          id="busService"
                          name="busService"
                          label={<span style={{ color: "blue" }}>Bus Service</span>}
                          checked={this.state.busRouteOption}
                          onChange={this.busServiceCheckHandle}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={6} style={{ marginRight: '-1rem' }}>
                        <AvField type="select" name="busRouteId" label="Select Bus Route"
                          disabled={!this.state.busRouteOption}
                          value={selectedCell?.userPayDetail?.busRouteId}
                          validate={{
                            required: {
                              value: !!this.state.busRouteOption,
                              errorMessage: 'This field is required.'
                            }
                          }}
                        >
                          <option value=''>Choose Bus Route</option>
                          {busRouteFareList.map((data, index) => { return (<option key={index} value={data.busRouteId} style={{ color: "black" }}>{data.route}</option>) })}
                        </AvField>
                      </Col>
                      <Col  xs={12} sm={6} md={6} lg={6} style={{marginRight:'-1rem'}}>
                        <AvField name="deductionAmt" label="Deduction Amount Apply" placeholder="00"
                          value={this.state.deductionAmount}
                          onChange={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.updateDeductionAmtHandler(e.target.value);
                          }}
                          validate={{
                            required: {
                              value: false,
                              errorMessage: 'This field is required.'
                            },
                            pattern: {
                              value: /^\d+(\.\d+)?$/,
                              errorMessage: 'Only Number Accepted'
                            },
                            async: (value, ctx, input, cb) => {
                              const pattern = /^[0-9]+$/
                              if (value && !pattern.test(value)) {
                                cb('Invalid Number')
                              } else if (value && pattern.test(value) && !(Number(value) > 0)) {
                                cb('Not valid amount')
                              } else if (value && Number(value) > Number(this.state.maxDeductionAmt)) {
                                cb(`Deduction cannot exceed monthly fee ${this.state.maxDeductionAmt}`)
                              } else {
                                cb(true)
                              }
                            }
                          }}
                        />
                      </Col>
                      {this.state.isDeductionAmtUpdated && Number(this.state.deductionAmount) > 0 && (
                      <>
                        <Col xs={12} sm={6} md={6} lg={6} >
                          <AvField name="password" label="Password" placeholder="Enter Password" type="password"
                            innerRef={this.setPasswordInputRef}
                            inputStyle={{ WebkitTextSecurity: 'disc', MozTextSecurity: 'disc' }}
                            onCopy={(e) => e.preventDefault()}
                            onCut={(e) => e.preventDefault()}
                            onPaste={(e) => e.preventDefault()}
                            autoComplete="new-password"
                          validate={{
                              required: {
                                value: true,
                                errorMessage: 'This field is required.'
                              }
                          }}/>
                        </Col>
                      </>
                      )}
                      {(this.state.isDeductionAmtUpdated || Number(this.state.deductionAmount) > 0) && (
                      <>
                        <Col xs={12} sm={12} md={12} lg={12} >
                          <AvField name="reason" label="Deduction Reason" placeholder="Enter Deduction Reason" 
                            value={this.state.selectedCell?.userPayDetail?.deductionInfo?.reason || ''} 
                            validate={{
                                required: {
                                  value: true,
                                  errorMessage: 'This field is required.'
                                }
                            }}
                          />
                        </Col>
                      </>
                      )}
                    </Row>
                    <Row>
                      <Col className='text-center'>
                        <Button type="submit">Submit</Button>
                      </Col>
                      <Col className='text-center'>
                        <Button variant="secondary" onClick={this.closeOtherSettingModal} >Cancel</Button>
                      </Col>
                    </Row>
                  </AvForm>
                </div>
              </div>
            </BlockUi>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default Payment;
